console.log('Swiper loaded:', typeof Swiper !== 'undefined');

// Define all possible variant classes in one place at the top of the file
const VARIANT_CLASSES = [
  "italian-riviera",
  "african-sandalwood", 
  "french-cognac",
  "maldivian-palm",
  "oasis-bundle",
  "oasis-duo",
  "coastal-duo",
  "luxury-duo",
  "tropical-duo",
  "sunset-duo",
  "villa-duo",
  "sample-pack",
  "fav-trio"
];

// Helper function to remove all variant classes
function removeAllVariantClasses() {
  const classString = VARIANT_CLASSES.join(' ');
  $("body").removeClass(classString);
  $(".main-product").removeClass(classString);
}

function updateProductPrice(options) {
    // Check if this is a Loop-initiated toggle between subscription and OTP
    const isLoopSubscriptionToggle = options && options.fromLoop === true;
    
    // Check for our global flag that indicates we're in a subscription toggle context
    const isLoopContextActive = window._isLoopPriceUpdate === true;
    
    // Get stack trace to identify caller
    const stackTrace = new Error().stack || '';
    const isCalledFromSubscriptionToggle = 
        stackTrace.includes('changeInSellingPlanGroupLoop') || 
        stackTrace.includes('changeInDeliveryOptionLoop');
    
    // For debugging
    console.log("📦 updateProductPrice called", {
        isLoopSubscriptionToggle,
        isLoopContextActive,
        isCalledFromSubscriptionToggle,
        caller: stackTrace.split('\n')[2] || 'unknown',
        options
    });
    
    // Get active quantity selection and product type
    const activeQty = $(".qty-pack-select.active").attr("ref");
    const productType = $(".main-product").attr("ref");
    const isBundlesView = $(".main-product").hasClass("bundles-view");
    if (!activeQty) return;

    // Get current quantity
    const currentQty = parseInt(activeQty);
    
    // Base prices for each quantity pack (one-time purchase)
    const basePrices = isBundlesView ? {
        1: 69.99,  // 100 loads bundle
        2: 139.99   // 200 loads bundle
    } : {
        1: 34.99,  // 50 loads
        2: 69.99,  // 100 loads
        3: 139.99   // 200 loads
    };
    
    // Exact subscription prices (no percentage calculation)
    const subscriptionPrices = isBundlesView ? {
        1: 49.99,  // 100 loads bundle
        2: 74.99   // 200 loads bundle
    } : {
        1: 24.99,  // 50 loads
        2: 49.99,  // 100 loads
        3: 74.99   // 200 loads
    };
    
    // Get base price for current quantity
    const basePrice = basePrices[currentQty];
    if (!basePrice) return;
    
    console.log("💲 Using base price:", basePrice, "for qty:", currentQty);
    
    // If this is just a subscription toggle (not a quantity change), and Loop is handling it, let Loop do its thing
    if ((isLoopSubscriptionToggle || isLoopContextActive || isCalledFromSubscriptionToggle) && 
        !options?.forceUpdate) {
        console.log("⚠️ Skipping price overrides for Loop subscription toggle");
        
        // However, we still want to update the price-per-load display
        const loads = isBundlesView ? {
            1: 100,  // 100 loads bundle
            2: 200   // 200 loads bundle
        } : {
            1: 50,   // 50 loads
            2: 100,  // 100 loads
            3: 200   // 200 loads
        };
        
        const totalLoads = loads[currentQty];
        if (totalLoads) {
            const pricePerLoad = (basePrice / totalLoads).toFixed(2);
            document.querySelectorAll('.priceperload-txt').forEach(element => {
                element.textContent = `($${pricePerLoad} / Load)`;
            });
        }
        
        return;
    }
    
    console.log("🔄 Updating all prices for quantity change");
    
    // Update one-time purchase price
    const oneTimePriceElement = document.querySelector('#loop-price-one-time');
    const oneTimePriceOriginalElement = document.querySelector('#loop-price-one-time-original');
    
    if (oneTimePriceElement) {
        oneTimePriceElement.innerHTML = formatPrice(basePrice);
    }
    if (oneTimePriceOriginalElement) {
        oneTimePriceOriginalElement.innerHTML = formatPrice(basePrice);
    }
    
    // Update subscription prices with exact values
    document.querySelectorAll('.loop-subscription-group-price-amount').forEach(priceElement => {
        const subscriptionPrice = subscriptionPrices[currentQty];
        priceElement.innerHTML = formatPrice(subscriptionPrice);
    });
    
    // Update original subscription prices
    document.querySelectorAll('.loop-subscription-group-price-amount-original').forEach(priceElement => {
        // For sample pack, use $139.99 as the original price, otherwise use the base price
        const originalPrice = isSamplePack ? 174.99 : basePrice;
        priceElement.innerHTML = `<s>${formatPrice(originalPrice)}</s>`;
    });
    
    // Update price per load displays
    const loads = isBundlesView ? {
        1: 100,  // 100 loads bundle (2-pack)
        2: 200   // 200 loads bundle
    } : {
        1: 50,   // 50 loads
        2: 100,  // 100 loads
        3: 200   // 200 loads
    };
    
    const totalLoads = loads[currentQty];
    if (totalLoads) {
        const pricePerLoad = (basePrice / totalLoads).toFixed(2);
        document.querySelectorAll('.priceperload-txt').forEach(element => {
            element.textContent = `($${pricePerLoad} / Load)`;
        });
    }
    
    // Show subscription discount badges only on subscription options
    document.querySelectorAll('.loop-subscription-group-discount-badge:not(.loop-subscription-group-discount-badge-onetime)').forEach(badge => {
        badge.classList.remove('loop-display-none');
        // Calculate actual savings
        const savings = Math.round(((basePrice - subscriptionPrices[currentQty]) / basePrice) * 100);
        // For sample pack, always show 37%
        const isSamplePack = $(".main-product").attr("ref") === "sample-pack";
        badge.textContent = isSamplePack ? 'SAVE 37%' : `SAVE ${savings}%`;
    });
    
    // Hide one-time purchase discount badge
    document.querySelector('.loop-subscription-group-discount-badge-onetime')?.classList.add('loop-display-none');

    // Update quantity input based on product type
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (qtyInput) {
        // For bundles, qty 1 = 100 loads, qty 2 = 200 loads
        // For singles, qty matches the pack selection
        qtyInput.value = productType === 'oasis-bundle' ? 1 : currentQty;
        
        // Trigger change event to update Loop's internal state
        const event = new Event('change', { bubbles: true });
        qtyInput.dispatchEvent(event);
    }

    document.querySelectorAll('.loop-subscription-group-price-amount-original').forEach(el => {
        el.classList.remove('loop-display-none');
      });
}

function formatPrice(price) {
    return `$${price.toFixed(2)}`;
}

function selectLoopSubscription(){
    // Wait for jQuery and Loop to be ready
    if (typeof $ === 'undefined' || typeof initLoopWidget === 'undefined') {
        console.log('Waiting for dependencies...');
        setTimeout(selectLoopSubscription, 100);
        return;
    }

    const $loopFieldset = $("#loop-selling-plan-fieldset");
    if (!$loopFieldset.length) return;
    
    const productData = $loopFieldset.attr("data-product");
    const selectedVariantId = $loopFieldset.attr("data-selected-variant-id");
    
    if (!productData || !selectedVariantId) return;
    
    try {
        const productJson = JSON.parse(productData);
        const $subscriptionRadio = $(`.featured-product #loop-product-variant-${selectedVariantId} .loop-subscription-group-radio`);
        
        if ($subscriptionRadio.length) {
            $subscriptionRadio.trigger('click');
        }
    } catch (error) {
        console.warn('Error parsing Loop product data:', error);
    }
}

function updateLoads() {
    // Get product type and variant
    let productType = $(".main-product").attr("ref");
    let variant = $(".main-product").attr("ref2");
    
    // Early return for bundles - we'll handle this separately later
    if (productType === 'oasis-bundle') return;
    
    // For singles products:
    // Calculate total loads based on pack size
    let totalLoads = 50; // Base load size
    if (variant === '1-pack') totalLoads = 50;  // 1x
    if (variant === '2-pack') totalLoads = 100; // 2x
    if (variant === '3-pack') totalLoads = 200; // 4x
    
    // Get current price from Loop
    let currentPrice = 0;
    const isSubscription = document.querySelector('.loop-subscription-group-radio:checked');
    if (isSubscription) {
        // Get subscription price
        const priceElement = isSubscription.closest('.loop-subscription-group')
            ?.querySelector('.loop-subscription-group-price-amount');
        if (priceElement) {
            currentPrice = parseFloat(priceElement.textContent.replace(/[^0-9.]/g, ''));
        }
    } else {
        // Get one-time purchase price
        const oneTimePriceElement = document.querySelector('#loop-price-one-time');
        if (oneTimePriceElement) {
            currentPrice = parseFloat(oneTimePriceElement.textContent.replace(/[^0.0-9]/g, ''));
        }
    }
    
    // Calculate price per load
    let pricePerLoad = currentPrice > 0 ? (currentPrice / totalLoads).toFixed(2) : 0;
    
    // Update all displays
    // Update the loads quantity in each pack selector
    $(`.qty-pack-1 .loads-qty`).html('50');
    $(`.qty-pack-2 .loads-qty`).html('100');
    $(`.qty-pack-3 .loads-qty`).html('200');
    
    // Update the price per load text for each pack
    $(`.qty-pack-1 .priceperload-txt`).html(`($${(currentPrice/50).toFixed(2)} / Load)`);
    $(`.qty-pack-2 .priceperload-txt`).html(`($${(currentPrice/100).toFixed(2)} / Load)`);
    $(`.qty-pack-3 .priceperload-txt`).html(`($${(currentPrice/200).toFixed(2)} / Load)`);
    
    // Also update the legacy displays if they exist
    $(".main-product .loads_qty").html(totalLoads + " Loads");
    $(".main-product .loads_price").html(pricePerLoad + "¢ per load");
}

function updateCart() {
  // Check if cart is empty first
  const cartItems = $(".cart-drawer .cart-item");
  if (cartItems.length === 0) {
    console.log('Cart is empty, skipping item updates');
    
    // Still update free shipping bar if it exists
    updateFreeShippingBar();
    return;
  }
  
  cartItems.each(function() {
      const $item = $(this);
      const $productColor = $item.find(".product_color");
      const $productPack = $item.find(".product_pack");
      const $quantityInput = $item.find(".quantity__input");
      const $displayPrice = $item.find(".display_price");
      
      // Skip if required elements don't exist
      if (!$productColor.length || !$productPack.length || !$quantityInput.length) return;
      
      const option_color = $productColor.html() || '';
      const title = option_color.replace("-", " ");
      $item.find(".cart-item__name").html(title);
      
      const variant = $productPack.html() || '';
      let info_text = "50 Loads (1 Pack)";
      let base_price = 29.99;
      let load = 50;
      let pack = 1;
      const qty = $quantityInput.val() || 1;
      
      if(variant == '1-pack') { 
          load = 50;
          pack = 1;
          base_price = 29.99;
      }
      if(variant == '2-pack') { 
        load = 100;
        pack = 2;
        base_price = 59.98;
      }
      if(variant == '3-pack') { 
        load = 150;
        pack = 3;
        base_price = 89.97;
      }

      if(option_color=='oasis-bundle') {
        load = load*2;
      }

      const total_loads = load*qty;
      const total_packs = pack*qty;
      info_text = total_loads+" Loads ("+total_packs+" Pack)"; 
    
      const $productInfo = $item.find(".product-option-info");
      if ($productInfo.length) {
        $productInfo.addClass("color_"+option_color);
        $productInfo.html(info_text);
      }

      //add discount price
      if ($displayPrice.length) {
        const current_price = parseFloat($displayPrice.html().trim().replace('$', '')) || 0;
        const original_price = (qty*base_price).toFixed(2);
        
        if(original_price != current_price && option_color != 'oasis-bundle'){
          $item.find(".cart-item__old-price").html('$'+original_price);
        }
      }
  });

  // Update free shipping bar
  /* updateFreeShippingBar(); */
}

// Helper function to update free shipping bar
function updateFreeShippingBar() {
  try {
    const $freeShippingBar = $(".free_shipping_bar");
    
    // If shipping bar doesn't exist, exit early
    if (!$freeShippingBar.length) return;
    
    // Default to 0 for empty cart
    let total_price = 0;
    
    const $totalValue = $(".totals__total-value");
    if ($totalValue.length) {
      let priceText = $totalValue.html() || '0';
      // Clean up the price string
      total_price = parseFloat(priceText.trim().replace('$', '').replace(' USD', '')) || 0;
    }
    
    // Get the free shipping threshold
    const fsb_price = parseFloat($freeShippingBar.attr('ref')) || 0;
    
    // Calculate remaining amount and generate text
    const rem_amount = Math.max(fsb_price - total_price, 0);
    const fsb_text = rem_amount > 0 ? 
      `you are $${rem_amount.toFixed(2)} from free shipping!` : 
      'YOUR ORDER HAS FREE SHIPPING!';
    
    // Calculate progress percentage (capped at 100%)
    const fsb_progress = Math.min((total_price/fsb_price)*100, 100);
    
    // Generate HTML content
    const fsb_content = `
      <div class="progress-text">${fsb_text}</div>
      <div class="progress">
        <div class="progress-bar" role="progressbar" style="width: ${fsb_progress}%" 
          aria-valuenow="${fsb_progress}" aria-valuemin="0" aria-valuemax="100">
        </div>
      </div>
    `;
    
    // Update the HTML
    $freeShippingBar.html(fsb_content);
  } catch (error) {
    console.error('Error updating free shipping bar:', error);
  }
}

$(".tab-pill").click(function(){
  const ref = $(this).attr("ref");
  $(".tab-pill").removeClass("active");
  $('[ref="'+ref+'"]').addClass("active");

  $(".tab-pane").removeClass("active");
  $("."+ref).addClass("active");
});



const vari_class =  $(".main-product").attr("ref");
$("body").addClass(vari_class);
$(".oasis-pack-title").hide();

// Update the color swatch click handler
$(".color-swatch").click(function(){
    removeAllVariantClasses();
    const ref = $(this).attr("ref");
    $(".main-product").attr("ref", ref);
    $("body").addClass(ref);

    // Update title
    let title = ref.replace(/-/g, " "); // Replace all dashes with spaces
    // Properly capitalize the title
    title = title.split(' ').map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
    
    // Update all elements with pt_alter class
    $(".pt_alter").html(title);

    // Show/hide oasis-pack-title based on the active variant
    if (ref === "oasis-bundle") {
        $(".oasis-pack-title").show();
    } else {
        $(".oasis-pack-title").hide();
    }

    // Handle sample pack variant
    const isSamplePack = ref === "sample-pack";
    const isFavTrio = ref === "fav-trio";

    if (isSamplePack) {
        // For sample pack, hide all quantity selectors except 200 loads
        $(".qty-pack-select").hide();
        $(".qty-pack-3.qty-pack-select").show();
        $(".qty-pack-select").removeClass("active");
        $(".qty-pack-3.qty-pack-select").addClass("active");
        
        // Make sure the bundle pack is hidden
        $(".bundle-qty-pack").hide();
        // Hide the trio pack
        $(".trio-qty-pack").hide();
        // Make sure the single pack is shown
        $(".qty-pack:not(.bundle-qty-pack)").show();
        
        // Set quantity to 1 and max to 1
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) {
            qtyInput.value = 1;
            qtyInput.setAttribute('max', '1');
            // Trigger change event
            const event = new Event('change', { bubbles: true });
            qtyInput.dispatchEvent(event);
        }
    } else if (isFavTrio) {
        // Hide both standard and bundle qty packs
        $(".qty-pack").hide();
        $(".bundle-qty-pack").hide();
        
        // Show the trio pack
        $(".trio-qty-pack").show();
        
        // Set quantity to 1 and max to 1
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) {
            qtyInput.value = 1;
            qtyInput.setAttribute('max', '1');
            // Trigger change event
            const event = new Event('change', { bubbles: true });
            qtyInput.dispatchEvent(event);
        }
    } else {
        // Check if this is a bundle variant
        const isBundleVariant = ['oasis-duo', 'coastal-duo', 'luxury-duo', 'tropical-duo', 'sunset-duo', 'villa-duo', 'oasis-bundle'].includes(ref);
        
        if (isBundleVariant) {
            console.log("Bundle variant detected:", ref);
            // For bundle variants, first ensure correct containers are visible
            $(".qty-pack:not(.bundle-qty-pack)").hide();
            $(".bundle-qty-pack").show();
            
            // Then show both 100 and 200 load buttons
            $(".bundle-qty-pack .qty-pack-select").show();
            $(".qty-pack-select").removeClass("active");
            $(".bundle-qty-pack .qty-pack-1").addClass("active");
            
            // Remove any quantity restrictions
            const qtyInput = document.querySelector('input[name="quantity"]');
            if (qtyInput) {
                qtyInput.removeAttribute('max');
                qtyInput.value = 1;
            }
        } else {
            console.log("Single variant detected:", ref);
            // For single variants, first ensure correct containers are visible
            $(".bundle-qty-pack").hide();
            $(".qty-pack:not(.bundle-qty-pack)").show();
            
            // Then show all three options
            $(".qty-pack:not(.bundle-qty-pack) .qty-pack-select").show();
            $(".qty-pack-select").removeClass("active");
            $(".qty-pack:not(.bundle-qty-pack) .qty-pack-2").addClass("active");
            
            // Remove any quantity restrictions
            const qtyInput = document.querySelector('input[name="quantity"]');
            if (qtyInput) {
                qtyInput.removeAttribute('max');
                qtyInput.value = 2;
            }
        }
    }

    // Get the current pack size and update the variant ID
    const packSize = $(".main-product").attr("ref2")?.replace('-pack', '') || '2';
    updateVariantIdByPackSize(packSize, ref);

    setTimeout(selectLoopSubscription, 10);
});


$(".vs-Pack label").click(function(){
  const ref2 = $(this).find(".vref").html().trim();
  $(".main-product").attr("ref2", ref2);
  updateLoads();
});


$(".vs-gallery").click(function(){
  $("video")[0].pause();
})


// Commented out to let Loop handle price updates directly
// $(".loop-subscription-group-radio").click(function () {
//   updateProductPrice();
// })

// Commented out to let Loop handle price updates directly
// $(".loop-one-time-purchase-option-radio").click(function () {
//   updateProductPrice();
// })

$(".loop-selling-plan-selector").change(function () {
  updateProductPrice();
})



$(".vs-Pack").click(function () {
  setTimeout(updateProductPrice, 300);
});

$(".vs-Color").click(function () {
  //update qty
  const ref =  $(".main-product").attr("ref");
  if(ref=='oasis-bundle') {
      $(".qty-pack:not(.bundle-qty-pack)").hide();
      $(".bundle-qty-pack").show();
      $(".qty-pack-select").removeClass("active");
      $(".bundle-qty-pack .qty-pack-1").addClass("active");
      let qty = "1";
      $(".main-product").attr("ref2", qty+"-pack");
      $(".quantity__input").val(qty);
  } else {
      $(".bundle-qty-pack").hide();
      $(".qty-pack:not(.bundle-qty-pack)").show();
      $(".qty-pack-select").removeClass("active");
      $(".qty-pack:not(.bundle-qty-pack) .qty-pack-2").addClass("active");
      let qty = "2";
      $(".main-product").attr("ref2", qty+"-pack");
      $(".quantity__input").val(qty);
  }
  updateProductPrice();
  setTimeout(updateProductPrice, 1000);
});


// Add subscription change handlers
document.addEventListener('DOMContentLoaded', function() {
    // Monitor subscription option changes
    document.querySelectorAll('.loop-subscription-group-radio, .loop-one-time-purchase-option-radio').forEach(radio => {
        radio.addEventListener('change', function(e) {
            console.log('Subscription option changed:', {
                id: this.dataset.id,
                name: this.dataset.name,
                productId: this.dataset.productId,
                checked: this.checked
            });
            updateProductPrice({ forceUpdate: true });
        });
    });
});

// Initialize correct quantity on page load
document.addEventListener('DOMContentLoaded', function() {
    console.log('Initializing default quantity...');
    
    // Find active quantity pack
    const activeQtyPack = document.querySelector('.qty-pack-select.active');
    if (activeQtyPack) {
        const packSize = activeQtyPack.getAttribute('ref');
        console.log('Initial active pack size:', packSize);
        
        // Convert pack size to quantity
        let quantity = 1;
        if (packSize === '1') quantity = 1;  // 50 loads
        if (packSize === '2') quantity = 2;  // 100 loads
        if (packSize === '3') quantity = 4;  // 200 loads
        
        console.log('Setting initial quantity to:', quantity);
        
        // Set initial quantity
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) {
            qtyInput.value = quantity;
            
            // Wait for Loop to initialize
            setTimeout(() => {
                // Trigger Loop's quantity update
                qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
                
                // Re-trigger the current subscription option
                const currentOption = document.querySelector('input[name="loop_purchase_option"]:checked');
                if (currentOption && window.changeInSellingPlanGroupLoop) {
                    const event = new Event('change', { bubbles: true });
                    Object.defineProperty(event, 'target', { value: currentOption });
                    window.changeInSellingPlanGroupLoop(event);
                }
            }, 500);
        }
    }
});

// Define quantity mapping for different product types - Now using quantityMappings instead
// const quantityMap = {
//     single: { '1': 1, '2': 2, '3': 4 },  // 3-pack is 4 quantity
//     bundle: { '1': 1, '2': 2 }
// };

// Add quantity pack click handler
$(".qty-pack-select").click(function() {
    // Remove active class from all packs
    $(".qty-pack-select").removeClass("active");
    
    // Add active class to clicked pack
    $(this).addClass("active");
    
    // Get the quantity from the ref attribute
    const packSize = $(this).attr("ref");
    const productType = $(".main-product").attr("ref");
    
    console.log(`🔍 Pack size ${packSize} clicked for ${productType}`);
    
    // Toggle sub-benefits-gift-eligible visibility based on pack size
    const giftEligibleElements = document.querySelectorAll('.sub-benefits-gift-eligible');
    if (packSize === '1') {
        // Hide gift-eligible elements when 50 loads is selected
        giftEligibleElements.forEach(element => {
            element.style.display = 'none';
        });
        
        // Set a data attribute to track the state
        document.body.setAttribute('data-gift-eligible-hidden', 'true');
        
        // Set up periodic checking to ensure elements stay hidden after widget reloads
        setTimeout(() => {
            const elementsToHide = document.querySelectorAll('.sub-benefits-gift-eligible');
            elementsToHide.forEach(element => {
                element.style.display = 'none';
            });
        }, 500);
        
        // Additional check after a longer delay to catch any late widget reloads
        setTimeout(() => {
            const elementsToHide = document.querySelectorAll('.sub-benefits-gift-eligible');
            elementsToHide.forEach(element => {
                element.style.display = 'none';
            });
        }, 1500);
    } else {
        // Show gift-eligible elements for other pack sizes
        giftEligibleElements.forEach(element => {
            element.style.display = '';
        });
        
        // Remove the data attribute
        document.body.removeAttribute('data-gift-eligible-hidden');
    }
    
    // Update the ref2 attribute on main-product
    $(".main-product").attr("ref2", packSize+"-pack");
    
    // Ensure all forms have quantity inputs
    ensureQuantityInputsExist();
    
    // Use our centralized function to update quantity inputs consistently
    const updatedQuantity = updateQuantityFromPackSize();
    console.log(`✅ Updated quantity to ${updatedQuantity} after pack size selection`);
    
    // Double-check all forms for quantity inputs
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form, index) => {
        const quantityInput = form.querySelector('input[name="quantity"]');
        if (quantityInput) {
            console.log(`✅ Form ${index} has quantity input with value: ${quantityInput.value}`);
        } else {
            console.warn(`⚠️ Form ${index} is still missing quantity input after update`);
        }
    });
    
    // Update the variant ID in the form based on the pack size
    updateVariantIdByPackSize(packSize, productType);
    
    // Apply correct prices for the new pack size
    applyPackSizePrices();
    
    // Need to re-trigger the subscription state
    setTimeout(() => {
        console.log("🔄 Re-applying current subscription option after qty change");
        // Get current selection (subscription or one-time)
        const currentOption = document.querySelector('input[name="loop_purchase_option"]:checked');
        if (currentOption) {
            // Create and dispatch click event
            currentOption.click();
            updateProductPrice({ forceUpdate: true });
        }
    }, 100);
});

/**
 * Updates the variant ID in the product form based on pack size and product type
 * @param {string} packSize - The pack size (1, 2, or 3)
 * @param {string} productType - The product type/fragrance (from main-product ref attribute)
 */
function updateVariantIdByPackSize(packSize, productType) {
    // Validate inputs
    if (!packSize || !productType) {
        console.log('📦 Missing required parameters:', { packSize, productType });
        return null;
    }

    // Convert packSize to string for consistent comparison
    packSize = String(packSize);
    
    console.log('📦 Updating variant ID for pack size:', packSize, 'product type:', productType);
    
    // Special case for sample pack and fav trio - always use variant for 200 loads with quantity 1
    const isSamplePack = productType === 'sample-pack';
    const isFavTrio = productType === 'fav-trio';
    if (isSamplePack || isFavTrio) {
        console.log(`📦 ${isSamplePack ? 'Sample pack' : 'Fav trio'} detected, using fixed variant ID for 200 loads`);

        // Force 3-pack for sample pack and fav trio (200 loads)
        packSize = '3';
        
        // Set quantity to 1 for sample pack and fav trio
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) {
            qtyInput.value = 1;
            qtyInput.setAttribute('max', '1'); // Limit max quantity to 1
            console.log(`📦 ${isSamplePack ? 'Sample pack' : 'Fav trio'}: Setting quantity to 1 and max to 1`);
            
            // Dispatch change event
            const event = new Event('change', { bubbles: true });
            qtyInput.dispatchEvent(event);
        }
    } else if (productType === 'oasis-bundle') {
        // For bundles, quantity 1 = 100 loads, quantity 2 = 200 loads
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) {
            qtyInput.value = packSize; // Direct mapping for bundles
            qtyInput.removeAttribute('max'); // Remove any max limit
            console.log(`📦 Bundle: Setting quantity to ${packSize}`);
            
            // Dispatch change event
            const event = new Event('change', { bubbles: true });
            qtyInput.dispatchEvent(event);
        }
    }
    
    // Find all variant inputs in the page
    const variantInputs = document.querySelectorAll('input[name="id"]');
    if (!variantInputs || variantInputs.length === 0) {
        console.log('ℹ️ No variant inputs found, skipping update');
        return null;
    }
    
    // Get all product forms (including the one in Loop widget)
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    console.log(`📋 Found ${productForms.length} product forms`);
    
    if (!productForms.length) {
        console.log("ℹ️ Product form not found, skipping update");
        return null;
    }
    
    // Get current product variants as JSON from the variant-selects
    const variantSelector = document.querySelector('variant-selects');
    if (!variantSelector) {
        console.log("ℹ️ Variant selector not found, skipping update");
        return null;
    }
    
    // Get variants from the JSON script in variant-selects
    const variantScript = variantSelector.querySelector('script[type="application/json"]');
    if (!variantScript) {
        console.log("ℹ️ Variant data not found, skipping update");
        return null;
    }
    
    try {
        // Parse the variants JSON
        const variants = JSON.parse(variantScript.textContent);
        console.log(`📦 Found ${variants.length} variants`, variants);
        
        // Log all variant titles for debugging
        variants.forEach(variant => {
            console.log(`Variant: ${variant.title} (ID: ${variant.id})`);
        });
        
        // Try multiple matching strategies
        let selectedVariant = null;
        
        // Strategy 1: Match by exact title pattern "Type / Size-pack"
        if (!selectedVariant) {
            const normalizedType = productType.replace(/-/g, ' ');
            selectedVariant = variants.find(variant => {
                const title = variant.title.toLowerCase();
                return title.includes(normalizedType.toLowerCase()) && 
                       title.includes(`${packSize}-pack`);
            });
            
            if (selectedVariant) {
                console.log("✅ Found variant by exact title match", selectedVariant);
            }
        }
        
        // Strategy 2: Match by option values (often option2 is the pack size)
        if (!selectedVariant) {
            selectedVariant = variants.find(variant => {
                // Check if any option contains the pack size
                return (
                    (variant.option1 && variant.option1.toLowerCase().includes(`${packSize}-pack`)) ||
                    (variant.option2 && variant.option2.toLowerCase().includes(`${packSize}-pack`)) ||
                    (variant.option3 && variant.option3.toLowerCase().includes(`${packSize}-pack`))
                ) && (
                    // And if any option contains the product type
                    (variant.option1 && variant.option1.toLowerCase().includes(productType.toLowerCase())) ||
                    (variant.option2 && variant.option2.toLowerCase().includes(productType.toLowerCase())) ||
                    (variant.option3 && variant.option3.toLowerCase().includes(productType.toLowerCase()))
                );
            });
            
            if (selectedVariant) {
                console.log("✅ Found variant by option values", selectedVariant);
            }
        }
        
        // Strategy 3: For bundles, just look for pack size in any option
        if (!selectedVariant && productType === 'oasis-bundle') {
            selectedVariant = variants.find(variant => {
                const title = variant.title.toLowerCase();
                return title.includes('bundle') && (
                    title.includes(`${packSize}-pack`) ||
                    (variant.option1 && variant.option1.toLowerCase().includes(`${packSize}-pack`)) ||
                    (variant.option2 && variant.option2.toLowerCase().includes(`${packSize}-pack`)) ||
                    (variant.option3 && variant.option3.toLowerCase().includes(`${packSize}-pack`))
                );
            });
            
            if (selectedVariant) {
                console.log("✅ Found bundle variant by pack size", selectedVariant);
            }
        }
        
        // Strategy 4: Fallback - use position in array based on pack size (likely 1st, 2nd, 3rd variants)
        if (!selectedVariant) {
            // Filter variants that contain the product type
            const typeVariants = variants.filter(variant => 
                variant.title.toLowerCase().includes(productType.replace(/-/g, ' ').toLowerCase())
            );
            
            if (typeVariants.length > 0) {
                // Pack sizes are usually organized 1, 2, 3 so packSize-1 should give us the correct variant
                const index = parseInt(packSize) - 1;
                if (index >= 0 && index < typeVariants.length) {
                    selectedVariant = typeVariants[index];
                    console.log("✅ Found variant by position in array", selectedVariant);
                }
            }
        }

        // If no variant is found, try to use the first available variant that matches the product type
        if (!selectedVariant) {
            const fallbackVariant = variants.find(variant => 
                variant.title.toLowerCase().includes(productType.replace(/-/g, ' ').toLowerCase())
            );
            if (fallbackVariant) {
                console.log("ℹ️ Using fallback variant:", fallbackVariant.title);
                selectedVariant = fallbackVariant;
            } else {
                console.log(`ℹ️ No matching variant found for ${productType}, pack size: ${packSize}`);
                return null;
            }
        }
        
        if (selectedVariant) {
            console.log(`🎯 Found matching variant: ${selectedVariant.title} (ID: ${selectedVariant.id})`);
            
            // Update the variant ID in all product forms
            productForms.forEach((form, index) => {
                const variantInput = form.querySelector('input[name="id"]');
                if (variantInput) {
                    const oldValue = variantInput.value;
                    variantInput.value = selectedVariant.id;
                    console.log(`✏️ Updated form ${index} variant ID from ${oldValue} to: ${selectedVariant.id}`);
                    
                    // Dispatch change event
                    const event = new Event('change', { bubbles: true });
                    variantInput.dispatchEvent(event);
                } else {
                    console.log(`ℹ️ Could not find input[name="id"] in form ${index}`);
                }
            });

            // Also update any variant ID inputs that might be in the Loop widget
            const loopInputs = document.querySelectorAll('input[name="loop_variant_id"]');
            loopInputs.forEach((input, index) => {
                const oldValue = input.value;
                input.value = selectedVariant.id;
                console.log(`✏️ Updated Loop input ${index} variant ID from ${oldValue} to: ${selectedVariant.id}`);
                
                // Dispatch change event
                const event = new Event('change', { bubbles: true });
                input.dispatchEvent(event);
            });
            
            // If there's a variantChange function in global.js, we should trigger it
            if (window.variantChange && typeof window.variantChange === 'function') {
                window.variantChange(selectedVariant);
                console.log("🔄 Triggered variantChange function");
            }
            
            // Trigger a custom event that other code might be listening for
            const variantChangeEvent = new CustomEvent('variantChange', {
                detail: { variant: selectedVariant }
            });
            document.dispatchEvent(variantChangeEvent);
            
            return selectedVariant.id;
        }
        
    } catch (error) {
        console.log("ℹ️ Error updating variant:", error.message);
        return null;
    }
    
    return null;
}

// Update the bundle qty pack click handler to also update the variant ID
$(".qty-pack-bundle-select").click(function () {
    $(".qty-pack-bundle-select").removeClass("active");
    $(this).addClass("active");
    let size = $(this).attr("ref");
    $(".main-product").attr("ref2", "bundle-"+size);
    
    // Use our centralized function to update quantity inputs consistently
    updateQuantityFromPackSize();
    
    // Update the variant ID in the form based on the bundle size
    updateVariantIdByPackSize(size, "oasis-bundle");
    
    updateProductPrice();
});

// Function to update button visibility and handle product switching
function updateButtonVisibility(isBundlesPage) {
    console.log('Updating button visibility for:', isBundlesPage ? 'bundles' : 'single products');
    
    // Get the product type - important for determining if this is a sample pack or fav trio
    const productType = $(".main-product").attr("ref");
    const isSamplePack = productType === 'sample-pack';
    const isFavTrio = productType === 'fav-trio';

    // For sample pack and fav trio, we want to show a different configuration
    if (isSamplePack || isFavTrio) {
        console.log(`Detected ${isSamplePack ? 'sample pack' : 'fav trio'}, showing single 200 loads option`);
        
        // Hide all quantity selectors first
        $(".qty-pack-select").hide();
        
        // Only show the 200 loads option for sample pack and fav trio
        $(".qty-pack-3.qty-pack-select").show();
        
        // Remove active class from all, then add to the 200 loads option
        $(".qty-pack-select").removeClass("active");
        $(".qty-pack-3.qty-pack-select").addClass("active");
        
        // Make sure the right quantity divs are showing - hide bundle, show singles
        $(".bundle-qty-pack").hide();
        $(".qty-pack:not(.bundle-qty-pack)").show();
        
        // Update the loads and price information
        $(".qty-pack-3 .loads-qty").text("200");
        $(".qty-pack-3 .priceperload-txt").text("($" + (89.99/200).toFixed(2) + " / Load)");
        
        // Set the quantity input to 1 and max to 1
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) {
            qtyInput.value = 1;
            qtyInput.setAttribute('max', '1');
            // Trigger change event
            const event = new Event('change', { bubbles: true });
            qtyInput.dispatchEvent(event);
        }
        
        // Apply the correct price
        applyPackSizePrices();
        
        return; // Exit early since we've handled the sample pack or fav trio
    }
    
    // Regular bundle/single product logic
    if (isBundlesPage) {
        // For bundle products (not sample pack or fav trio)
        const isValidBundleVariant = ['oasis-duo', 'coastal-duo', 'luxury-duo', 'tropical-duo', 'sunset-duo', 'villa-duo', 'oasis-bundle'].includes(productType);
        
        if (isValidBundleVariant) {
            console.log('Setting up bundle variant display for:', productType);
            // Hide singles qty pack, show bundle qty pack
            $(".qty-pack:not(.bundle-qty-pack)").hide();
            $(".bundle-qty-pack").show();
            
            // Ensure both bundle quantity buttons are visible
            $(".bundle-qty-pack .qty-pack-select").show();
            
            // Reset the toggle buttons state
            $("#show-singles").removeClass("active");
            $("#show-bundles").addClass("active");
            
            // Update the main-product class
            $(".main-product").addClass("bundles-view");
            
            // Remove any max quantity restriction
            const qtyInput = document.querySelector('input[name="quantity"]');
            if (qtyInput) {
                qtyInput.removeAttribute('max');
            }
            
            // Show current selection or default to first
            $(".bundle-qty-pack .qty-pack-select").removeClass("active");
            if($('.bundle-qty-pack .qty-pack-select.was-active').length) {
                $('.bundle-qty-pack .qty-pack-select.was-active').addClass('active').removeClass('was-active');
            } else {
                $('.bundle-qty-pack .qty-pack-1').addClass('active');
            }
        }
    } else {
        // For singles product
        const isValidSingleVariant = ['italian-riviera', 'african-sandalwood', 'maldivian-palm', 'french-cognac'].includes(productType);
        
        if (isValidSingleVariant) {
            console.log('Setting up single variant display for:', productType);
            // Hide bundle qty pack, show singles qty pack
            $(".bundle-qty-pack").hide();
            $(".qty-pack:not(.bundle-qty-pack)").show();
            
            // Ensure all single quantity buttons are visible
            $(".qty-pack:not(.bundle-qty-pack) .qty-pack-select").show();
            
            // First, ensure no pack selectors are active
            $(".qty-pack-select").removeClass("active");
            
            // Reset the toggle buttons state
            $("#show-bundles").removeClass("active");
            $("#show-singles").addClass("active");
            
            // Update the main-product class
            $(".main-product").removeClass("bundles-view");
            
            // Always default to 100 loads (qty-pack-2) for single products
            $('.qty-pack:not(.bundle-qty-pack) .qty-pack-2').addClass('active');
            
            // Set the ref2 attribute to "2-pack" for consistency
            $(".main-product").attr("ref2", "2-pack");
            
            // Update quantity input
            const qtyInput = document.querySelector('input[name="quantity"]');
            if (qtyInput) {
                qtyInput.value = 2; // Set to 2 for 100 loads
                const event = new Event('change', { bubbles: true });
                qtyInput.dispatchEvent(event);
            }
        }
    }
    
    // Update active references for restoring selections later
    $('.qty-pack-select.active').removeClass('was-active');
    
    // Only trigger the product price update if we're on the product page
    if ($('.main-product').length > 0) {
        try {
            // Force true to update all prices regardless of context
            updateProductPrice({ forceUpdate: true });
        } catch (e) {
            console.error("Error updating product price:", e);
        }
    }
}

// Initialize bundle variant selectors when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    console.log('Initializing bundle variant selectors');
    initBundleVariantSelectors();
    
    // Also reinitialize when the product form changes
    const productForm = document.querySelector('product-info');
    if (productForm) {
        const observer = new MutationObserver(function(mutations) {
            console.log('Product form changed, reinitializing bundle variant selectors');
            initBundleVariantSelectors();
        });
        
        observer.observe(productForm, {
            childList: true,
            subtree: true
        });
    }
});

function initBundleVariantSelectors() {
    // Get all bundle variant labels
    const bundleVariantLabels = $("label[for^='template--']").not('.color-swatch');
    
    // Remove any existing click handlers to prevent duplicates
    bundleVariantLabels.off('click');
    $("input[type='radio'][id^='template--']").not('.color-swatch').off('change');
    
    // Add click handler for bundle variant labels
    bundleVariantLabels.on('click', function() {
        // Remove active class from all bundle variant labels
        bundleVariantLabels.removeClass('active');
        
        // Add active class to clicked label
        $(this).addClass('active');
        
        // Get variant name and ref from the label
        let variantName = $(this).find('.variant-name, .visually-hidden').not('.label-unavailable').first().text();
        const ref = $(this).find('.vref').text() || $(this).attr('data-bundle') || variantName?.toLowerCase().replace(/\s+/g, '-');
        
        if (!variantName) {
            // Fallback to visible text if no hidden span
            variantName = $(this).text().trim();
        }
        
        // Update product title and attributes if we have a variant name
        if (variantName) {
            let formattedTitle = variantName;
            // Properly capitalize the title
            formattedTitle = formattedTitle.split(' ').map(word => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }).join(' ');
            
            // Update all elements with pt_alter class
            document.querySelectorAll('.pt_alter').forEach(el => {
                el.innerHTML = formattedTitle;
            });
            
            // Update main-product attributes and body classes
            const mainProduct = $('.main-product');
            if (mainProduct.length) {
                // Remove all variant classes
                removeAllVariantClasses();
                
                // Set the ref attribute to the current variant
                mainProduct.attr('ref', ref);
                // Add the new variant class to body
                $("body").addClass(ref);
            }
            
            // Show/hide oasis-pack-title based on the active variant
            if (ref === "oasis-bundle") {
                $(".oasis-pack-title").show();
            } else {
                $(".oasis-pack-title").hide();
            }
            
            // Handle quantity pack visibility based on variant type
            const isSamplePack = ref === "sample-pack";
            const isFavTrio = ref === 'favorite-trio';
            const isBundleVariant = ['oasis-duo', 'coastal-duo', 'luxury-duo', 'tropical-duo', 'sunset-duo', 'villa-duo', 'oasis-bundle'].includes(ref);
            
            if (isSamplePack || isFavTrio) {
                console.log("Sample pack or Fav trio selected in bundle variant handler");
                // For sample pack and fav trio, hide all quantity selectors except 200 loads
                $(".qty-pack-select").hide();
                $(".qty-pack-3.qty-pack-select").show();
                $(".qty-pack-select").removeClass("active");
                $(".qty-pack-3.qty-pack-select").addClass("active");
                
                // Make sure the bundle pack is hidden, singles pack is shown
                $(".bundle-qty-pack").hide();
                $(".qty-pack:not(.bundle-qty-pack)").show();
                
                // Set quantity to 1 and max to 1
                const qtyInput = document.querySelector('input[name="quantity"]');
                if (qtyInput) {
                    qtyInput.value = 1;
                    qtyInput.setAttribute('max', '1');
                    // Trigger change event
                    const event = new Event('change', { bubbles: true });
                    qtyInput.dispatchEvent(event);
                }
            } else if (isBundleVariant) {
                console.log("Bundle variant selected:", ref);
                // For bundle variants, show bundle quantity pack with both options
                $(".qty-pack:not(.bundle-qty-pack)").hide();
                $(".bundle-qty-pack").show();
                $(".bundle-qty-pack .qty-pack-select").show();
                $(".qty-pack-select").removeClass("active");
                $(".bundle-qty-pack .qty-pack-1").addClass("active");
                
                // Update ref2 attribute and quantity
                $(".main-product").attr("ref2", "1-pack");
                const qtyInput = document.querySelector('input[name="quantity"]');
                if (qtyInput) {
                    qtyInput.value = 1;
                    qtyInput.removeAttribute('max');
                    // Trigger change event
                    const event = new Event('change', { bubbles: true });
                    qtyInput.dispatchEvent(event);
                }
            } else {
                console.log("Single variant selected:", ref);
                // For single variants, show singles quantity pack with all options
                $(".bundle-qty-pack").hide();
                $(".qty-pack:not(.bundle-qty-pack)").show();
                $(".qty-pack:not(.bundle-qty-pack) .qty-pack-select").show();
                $(".qty-pack-select").removeClass("active");
                $(".qty-pack:not(.bundle-qty-pack) .qty-pack-2").addClass("active");
                
                // Update ref2 attribute and quantity
                $(".main-product").attr("ref2", "2-pack");
                const qtyInput = document.querySelector('input[name="quantity"]');
                if (qtyInput) {
                    qtyInput.value = 2;
                    qtyInput.removeAttribute('max');
                    // Trigger change event
                    const event = new Event('change', { bubbles: true });
                    qtyInput.dispatchEvent(event);
                }
            }
            
            // Update images
            updateProductImages(ref);
            
            // Ensure the corresponding radio input is checked
            const inputId = $(this).attr('for');
            const radioInput = $('#' + inputId);
            if (radioInput.length) {
                radioInput.prop('checked', true);
                // Trigger the change event
                radioInput.trigger('change');
            }
            
            // Update Loop subscription if needed
            setTimeout(selectLoopSubscription, 10);
            
            // Update the variant ID based on the current pack size
            const packSize = $(".main-product").attr("ref2")?.replace('-pack', '') || '2';
            updateVariantIdByPackSize(packSize, ref);
            
            // Update prices
            updateProductPrice({ forceUpdate: true });
        }
    });

    // Also listen for the native change event on the radio inputs
    $("input[type='radio'][id^='template--']").not('.color-swatch').on('change', function() {
        const label = $(`label[for="${this.id}"]`);
        if (!label.length) return;
        
        const variantName = label.find('.variant-name, .visually-hidden').not('.label-unavailable').first().text() || label.text().trim();
        if (variantName) {
            let formattedTitle = variantName;
            formattedTitle = formattedTitle.split(' ').map(word => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }).join(' ');
            
            // Update all elements with pt_alter class
            document.querySelectorAll('.pt_alter').forEach(el => {
                el.innerHTML = formattedTitle;
            });
        }
    });
}

$( document ).ready(function() {
    // Remove any existing variant classes first
    removeAllVariantClasses();
    
    // Then add the initial variant class
    const vari_class = $(".main-product").attr("ref");
    if (vari_class) {
        $("body").addClass(vari_class);
    }
    
    console.log('Document ready, initializing product page');
    const currentPath = window.location.pathname;
    console.log('Current path:', currentPath);
    const isBundlePage = currentPath.includes('bundles-laundry-detergent');
    console.log('Is bundle page:', isBundlePage);
    
    // Check if this is a sample pack or fav trio product first
    const productTitle = document.querySelector('.product__title')?.textContent?.trim();
    const isSamplePack = productTitle?.toLowerCase().includes('sample pack');
    const isFavTrio = productTitle?.toLowerCase().includes('fav trio');

    if (isSamplePack || isFavTrio) {
        console.log(`${isSamplePack ? 'Sample Pack' : 'Fav Trio'} detected during document ready`);
        const mainProduct = document.querySelector('.main-product');
        if (mainProduct) {
            mainProduct.setAttribute('ref', isSamplePack ? 'sample-pack' : 'fav-trio');
            // Update any title elements
            document.querySelectorAll('.pt_alter').forEach(el => {
                el.textContent = isSamplePack ? 'Sample Pack' : 'Fav Trio';
            });
        }
        // Run specific sample pack/fav trio initialization
        updateButtonVisibility(false); 
    } else {
        // Set initial state for non-sample pack and non-fav trio products
        console.log('Setting initial state');
        updateButtonVisibility(isBundlePage);
    }
    
    // Add click handlers for the buttons
    $("#show-singles, #show-bundles").off('click').on('click', function() {
        console.log('Toggle button clicked:', this.id);
        const clickedBundles = $(this).attr('id') === 'show-bundles';
        console.log('Clicked Bundles:', clickedBundles);
        const targetHandle = getProductHandle(clickedBundles ? 'bundles' : 'singles');
        const targetPath = `/products/${targetHandle}`;
        console.log('Target path:', targetPath);
        
        // Update URL without page reload
        window.history.pushState({ path: targetPath }, '', targetPath);
        console.log('URL updated to:', window.location.pathname);
        
        // Update visibility and product display
        updateButtonVisibility(!clickedBundles);
    });
    
    // Initialize product price
    console.log('Initializing product price');
    updateProductPrice();
    
    // Force a second update after a short delay to ensure everything is set
    setTimeout(() => {
        console.log('Running delayed price update');
        updateProductPrice();
    }, 300);
    
    // Handle bundle variant selection like color swatches
    initBundleVariantSelectors();
});

$(".quantity__input").click(function () {
   updateProductPrice();
});

for(var i = 1; i < 5; i++) {
  $(".marquee_content img").clone().prependTo( ".marquee_content" );
}


 $(".pg_scents li").click(function() {
  let scent = $(this).attr("ref");
  $(".vs-Color label[ref='"+scent+"']").trigger("click");
 });


//page igredint 

$(".ig-variant").click(function() {
  let scent = $(this).attr("ref");
  $(".pi-head li label").removeClass("active");
  $(this).addClass("active");
  $(".page-ingredients").removeClass("show-italian-riviera show-african-sandalwood show-french-cognac show-maldivian-palm");
  $(".page-ingredients").addClass("show-"+scent)
});

$(".unmatched_scents .multicolumn-card").click(function() {
     let link = $(this).find(".link").attr("href");
     window.location.href = link;
});


$(".footer-text a").click(function(e) {
  e.preventDefault();
  $(".footer-text").hide();
  $(".footer-form").show();
  $(".footer-form input").focus();
  
});

$(document).on("submit", "#add-to-cart-form", function(event) {
  event.preventDefault();
  console.log('🛒 Cart form submitted');
  
  const form = $(this);
  const submitButton = form.find('[type="submit"]');
  const formData = form.serialize();
  
  console.log('📦 Form data:', formData);
  
  // Disable submit button and show loading state
  submitButton.prop('disabled', true).addClass('loading');
  
  // First add the item to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  })
  .then(response => response.json())
  .then(item => {
    console.log('✅ Item added to cart:', item);
    
    // Then get the full cart state and sections
    return Promise.all([
      fetch('/cart.js').then(res => res.json()),
      fetch(`${window.location.pathname}?section_id=cart-drawer,cart-icon-bubble`).then(res => res.text())
    ]).then(([cart, sectionsHtml]) => {
      console.log('📊 Current cart state:', cart);
      console.log('📝 Got sections HTML');
      
      // Create a temporary container to parse the HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsHtml, 'text/html');
      
      // Extract the cart drawer and icon bubble sections
      const cartDrawerContent = doc.querySelector('[data-section="cart-drawer"]')?.innerHTML || '';
      const cartIconBubbleContent = doc.querySelector('[data-section="cart-icon-bubble"]')?.innerHTML || '';
      
      // Find the cart drawer element
      const cartDrawer = document.querySelector('cart-drawer');
      console.log('🎯 Cart drawer element:', cartDrawer ? 'Found' : 'Not found');
      
      if (!cartDrawer) {
        throw new Error('Cart drawer element not found');
      }
      
      // Update cart drawer contents with properly structured state
      console.log('🔄 Updating cart drawer contents...');
      cartDrawer.renderContents({
        sections: {
          'cart-drawer': cartDrawerContent,
          'cart-icon-bubble': cartIconBubbleContent
        },
        item_count: cart.item_count || 0
      });
      
      // Force drawer to open
      console.log('🚪 Forcing cart drawer to open...');
      cartDrawer.open();
      
      // Update any other cart-related elements
      console.log('🔄 Running final cart update...');
      updateCart();
    });
  })
  .catch((error) => {
    console.error('❌ Error in cart update process:', error);
    alert('There was an error adding this item to your cart. Please try again.');
  })
  .finally(() => {
    console.log('✨ Cart update process complete');
    submitButton.prop('disabled', false).removeClass('loading');
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const singlesProductHandle = 'laundry-detergent';
    const bundlesProductHandle = 'bundles-laundry-detergent';
    const productSection = document.querySelector('section[id^="MainProduct-"]');

    // Function to fetch and update product content
    async function fetchProductContent(handle) {
        try {
            console.log('Fetching product:', handle);
            
            // Show loading state
            const productSection = document.querySelector('section[id^="MainProduct-"]');
            if (!productSection) return;
            
            productSection.style.opacity = '0.5';
            
            // Fetch the section HTML with the new product
            const response = await fetch(`/products/${handle}?section_id=${productSection.id.split('-')[1]}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const html = await response.text();
            
            // Update URL without page reload
            const newUrl = `/products/${handle}`;
            window.history.pushState({ path: newUrl }, '', newUrl);
            
            // Parse the new content
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('section[id^="MainProduct-"]');
            
            if (newContent) {
                // Clean up existing Swiper instances
                if (window.mainSlider) {
                    window.mainSlider.destroy(true, true);
                    window.mainSlider = null;
                }
                if (window.thumbnailSlider) {
                    window.thumbnailSlider.destroy(true, true);
                    window.thumbnailSlider = null;
                }
                
                // Update the product section content with a fade transition
                productSection.innerHTML = newContent.innerHTML;
                
                // Update button visibility
                const isBundlesProduct = handle === 'bundles-laundry-detergent';
                updateButtonVisibility(isBundlesProduct);
                
                // Initialize Swiper and event handlers
                setTimeout(() => {
                    initSwipers();
                    initializeEventHandlers();
                    
                    // Restore opacity with a smooth transition
                    productSection.style.transition = 'opacity 0.3s ease';
                    productSection.style.opacity = '1';
                    
                    // Select first variant
                    const firstColorSwatch = document.querySelector('.color-swatch');
                    if (firstColorSwatch) {
                        firstColorSwatch.click();
                    }
                }, 50);
            }
            
        } catch (error) {
            console.error('Error in fetchProductContent:', error);
            // Restore opacity in case of error
            const productSection = document.querySelector('section[id^="MainProduct-"]');
            if (productSection) {
                productSection.style.opacity = '1';
            }
        }
    }

    // Function to initialize Swiper instances
    function initSwipers() {
        console.log('Attempting to initialize Swiper');
        
        // Get containers
        const mainSliderContainer = document.querySelector('.swiper-container.main-slider');
        const thumbnailSliderContainer = document.querySelector('.swiper-container.thumbnail-slider');

        if (!mainSliderContainer || !thumbnailSliderContainer) {
            console.error('Slider containers not found:', {
                main: !!mainSliderContainer,
                thumb: !!thumbnailSliderContainer
            });
            return;
        }

        console.log('Found slider containers, initializing Swiper instances');

        try {
            // Initialize thumbnail slider first
            const thumbnailSlider = new Swiper(thumbnailSliderContainer, {
                direction: 'vertical',
                slidesPerView: 4,
                spaceBetween: 10,
                watchSlidesProgress: true
            });

            // Initialize main slider
            const mainSlider = new Swiper(mainSliderContainer, {
                slidesPerView: 1,
                spaceBetween: 10,
                thumbs: {
                    swiper: thumbnailSlider
                },
                pagination: {
                    el: '.main-slider-pagination',
                    clickable: true,
                    type: 'bullets'
                }
            });

            // Debug pagination
            console.log('Custom.js - Pagination element:', document.querySelector('.main-slider-pagination'));
            console.log('Custom.js - Main slider pagination:', mainSlider.pagination);
            console.log('Custom.js - Pagination bullets:', document.querySelectorAll('.main-slider-pagination .swiper-pagination-bullet'));

            // Add event listeners to track slide changes and pagination updates
            mainSlider.on('slideChange', function () {
                console.log('Custom.js - Slide changed to:', mainSlider.activeIndex);
                console.log('Custom.js - Active bullet should be:', mainSlider.activeIndex);
                
                // Force update pagination active state
                setTimeout(() => {
                    const bullets = document.querySelectorAll('.main-slider-pagination .swiper-pagination-bullet');
                    bullets.forEach((bullet, index) => {
                        if (index === mainSlider.activeIndex) {
                            bullet.classList.add('swiper-pagination-bullet-active');
                        } else {
                            bullet.classList.remove('swiper-pagination-bullet-active');
                        }
                    });
                    console.log('Custom.js - Updated pagination bullets after slide change');
                }, 100);
            });

            // Add a periodic check to ensure pagination stays in sync
            setInterval(() => {
                if (mainSlider && mainSlider.activeIndex !== undefined) {
                    const bullets = document.querySelectorAll('.main-slider-pagination .swiper-pagination-bullet');
                    bullets.forEach((bullet, index) => {
                        if (index === mainSlider.activeIndex) {
                            bullet.classList.add('swiper-pagination-bullet-active');
                        } else {
                            bullet.classList.remove('swiper-pagination-bullet-active');
                        }
                    });
                }
            }, 500);

            // Add click handlers for thumbnails
            thumbnailSliderContainer.querySelectorAll('.swiper-slide').forEach((thumb, index) => {
                thumb.addEventListener('click', () => {
                    console.log('Thumbnail clicked:', index);
                    mainSlider.slideTo(index);
                });
            });

            // Store references globally
            window.mainSlider = mainSlider;
            window.thumbnailSlider = thumbnailSlider;

            console.log('Both sliders initialized successfully');

        } catch (error) {
            console.error('Error initializing Swiper:', error);
        }
    }

    // Function to initialize event handlers
    function initializeEventHandlers() {
        // Color/variant swatch handlers
        $(".color-swatch").off('click').on('click', function() {
            const ref = $(this).attr("ref");
            $(".color-swatch").removeClass("active");
            $(this).addClass("active");
            
            // Update product images
            updateProductImages(ref);
            
            // Update title with properly formatted text
            let title = ref.replace(/-/g, " "); // Replace all dashes with spaces
            // Properly capitalize the title
            title = title.split(' ').map(word => {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }).join(' ');
            
            // Update all elements with pt_alter class
            $(".pt_alter").html(title);
            
            // Show/hide oasis-pack-title based on the active variant
            if (ref === "oasis-bundle") {
                $(".oasis-pack-title").show();
          } else {
                $(".oasis-pack-title").hide();
            }
            
            setTimeout(selectLoopSubscription, 10);
        });
        
        // Quantity pack handlers
        $(".qty-pack-select").off('click').on('click', function() {
            // First remove active class from ALL pack selectors, not just within parent
            $(".qty-pack-select").removeClass("active");
            
            // Add active to the clicked one
            $(this).addClass("active");
            
            // Get the quantity and update the form
            const qty = $(this).attr("ref");
            $(".quantity__input").val(qty);
            
            // Toggle sub-benefits-gift-eligible visibility based on pack size
            const giftEligibleElements = document.querySelectorAll('.sub-benefits-gift-eligible');
            if (qty === '1') {
                // Hide gift-eligible elements when 50 loads is selected
                giftEligibleElements.forEach(element => {
                    element.style.display = 'none';
                });
                
                // Set a data attribute to track the state
                document.body.setAttribute('data-gift-eligible-hidden', 'true');
                
                // Set up periodic checking to ensure elements stay hidden after widget reloads
                setTimeout(() => {
                    const elementsToHide = document.querySelectorAll('.sub-benefits-gift-eligible');
                    elementsToHide.forEach(element => {
                        element.style.display = 'none';
                    });
                }, 500);
                
                // Additional check after a longer delay to catch any late widget reloads
                setTimeout(() => {
                    const elementsToHide = document.querySelectorAll('.sub-benefits-gift-eligible');
                    elementsToHide.forEach(element => {
                        element.style.display = 'none';
                    });
                }, 1500);
            } else {
                // Show gift-eligible elements for other pack sizes
                giftEligibleElements.forEach(element => {
                    element.style.display = '';
                });
                
                // Remove the data attribute
                document.body.removeAttribute('data-gift-eligible-hidden');
            }
            
            // Set the ref2 attribute to track selected pack size
            $(".main-product").attr("ref2", qty+"-pack");
            
            // Update prices and variant IDs
            updateProductPrice();
            
            // Update the variant ID based on the selected pack size
            const productType = $(".main-product").attr("ref");
            updateVariantIdByPackSize(qty, productType);
        });
        
        // Loop subscription handlers
        $(".loop-subscription-group-radio, .loop-one-time-purchase-option-radio").off('click').on('click', updateProductPrice);
        $(".loop-selling-plan-selector").off('change').on('change', updateProductPrice);
    }

    // Function to update product images based on variant
    function updateProductImages(variant) {
        console.log('updateProductImages called with variant:', variant);
        if (!variant) {
            console.log('No variant provided, exiting');
            return;
        }
        
        const mainSlider = document.querySelector('.swiper-container.main-slider');
        const thumbnailSlider = document.querySelector('.swiper-container.thumbnail-slider');
        
        if (!mainSlider || !thumbnailSlider) {
            console.log('Sliders not found - Main:', !!mainSlider, 'Thumbnail:', !!thumbnailSlider);
            return;
        }
        
        console.log('Processing slides');
        const mainSlides = mainSlider.querySelectorAll('.swiper-slide');
        const thumbnailSlides = thumbnailSlider.querySelectorAll('.swiper-slide');
        
        console.log('Found slides - Main:', mainSlides.length, 'Thumbnail:', thumbnailSlides.length);
        
        let visibleSlideFound = false;
        mainSlides.forEach((slide, index) => {
            const img = slide.querySelector('img');
            if (img) {
                const altText = img.alt.toLowerCase();
                const shouldShow = altText.includes(variant.toLowerCase());
                slide.style.display = shouldShow ? 'block' : 'none';
                if (shouldShow && !visibleSlideFound) {
                    visibleSlideFound = true;
                    console.log('First visible slide found at index:', index);
                }
            }
        });
        
        thumbnailSlides.forEach((slide, index) => {
            const img = slide.querySelector('img');
            if (img) {
                const altText = img.alt.toLowerCase();
                const shouldShow = altText.includes(variant.toLowerCase());
                slide.style.display = shouldShow ? 'block' : 'none';
            }
        });
        
        // Update Swiper instances if they exist
        if (window.mainSlider) {
            console.log('Updating main slider');
            window.mainSlider.update();
            window.mainSlider.slideTo(0);
        } else {
            console.log('Main slider instance not found');
        }
        if (window.thumbnailSlider) {
            console.log('Updating thumbnail slider');
            window.thumbnailSlider.update();
            window.thumbnailSlider.slideTo(0);
        } else {
            console.log('Thumbnail slider instance not found');
        }
    }

    // Set initial state based on current URL
    const currentPath = window.location.pathname;
    const isBundlePage = currentPath.includes(bundlesProductHandle);
    
    // Initial button setup
    const initialSinglesButton = document.getElementById('show-singles');
    const initialBundlesButton = document.getElementById('show-bundles');
    
    if (initialSinglesButton && initialBundlesButton) {
        // Add initial event listeners
        initialSinglesButton.addEventListener('click', () => fetchProductContent(singlesProductHandle));
        initialBundlesButton.addEventListener('click', () => fetchProductContent(bundlesProductHandle));
    }
});

// Bundle Product Image Switching
document.addEventListener('DOMContentLoaded', function() {
    const bundleProduct = document.querySelector('.product-form__input--swatch');
    if (bundleProduct) {
        const swatches = bundleProduct.querySelectorAll('input[type="radio"]');
        const mainSlider = document.querySelector('.swiper-main');
        const thumbnailSlider = document.querySelector('.swiper-thumbnails');
        
        if (mainSlider && thumbnailSlider) {
            swatches.forEach(swatch => {
                swatch.addEventListener('change', function() {
                    const variantName = this.value.toLowerCase().replace(/\s+/g, '-');
                    
                    // Update product title when variant changes
                    let formattedTitle = this.value;
                    // Properly capitalize the title
                    formattedTitle = formattedTitle.split(' ').map(word => {
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }).join(' ');
                    
                    // Update all elements with pt_alter class
                    document.querySelectorAll('.pt_alter').forEach(el => {
                        el.textContent = formattedTitle;
                    });
                    
                    // Handle image slides
                    const mainSlides = mainSlider.querySelectorAll('.swiper-slide');
                    const thumbnailSlides = thumbnailSlider.querySelectorAll('.swiper-slide');
                    
                    mainSlides.forEach(slide => {
                        const img = slide.querySelector('img');
                        if (img && img.alt.toLowerCase().includes(variantName)) {
                            slide.style.display = 'block';
                        } else {
                            slide.style.display = 'none';
                        }
                    });
                    
                    thumbnailSlides.forEach(slide => {
                        const img = slide.querySelector('img');
                        if (img && img.alt.toLowerCase().includes(variantName)) {
                            slide.style.display = 'block';
                        } else {
                            slide.style.display = 'none';
                        }
                    });
                    
                    // Update Swiper
                    if (mainSlider.swiper) {
                        mainSlider.swiper.update();
                    }
                    if (thumbnailSlider.swiper) {
                        thumbnailSlider.swiper.update();
                    }
                });
            });
        }
    }
});

// Update click handler for bundle qty selectors
$(".qty-pack-bundle-select").click(function () {
    $(".qty-pack-bundle-select").removeClass("active");
    $(this).addClass("active");
    let size = $(this).attr("ref");
    $(".main-product").attr("ref2", "bundle-"+size);
    
    // Use our centralized function to update quantity inputs consistently
    updateQuantityFromPackSize();
    
    // Update the variant ID in the form based on the bundle size
    updateVariantIdByPackSize(size, "oasis-bundle");
    
    updateProductPrice();
});

// Update load info text based on variant
document.addEventListener('DOMContentLoaded', function() {
  const loadInfo = document.querySelector('.load-info');
  const showSinglesBtn = document.getElementById('show-singles');
  const showBundlesBtn = document.getElementById('show-bundles');

  if (loadInfo) {
    // Check if we're on the bundles page
    const isBundlesPage = window.location.pathname.includes('bundles-laundry-detergent');
    
    // Set initial text based on URL
    loadInfo.textContent = isBundlesPage ? loadInfo.dataset.bundle : loadInfo.dataset.single;

    // Update on button click if buttons exist
    if (showSinglesBtn && showBundlesBtn) {
      showSinglesBtn.addEventListener('click', function() {
        loadInfo.textContent = loadInfo.dataset.single;
      });

      showBundlesBtn.addEventListener('click', function() {
        loadInfo.textContent = loadInfo.dataset.bundle;
      });
    }
  }
});

// Function to handle product switching with full page reload
function toggleProductView(showBundles) {
    // Determine the target product handle
    const productHandle = showBundles ? 'bundles-laundry-detergent' : 'laundry-detergent';
    
    // Construct the new URL
    const newUrl = `/products/${productHandle}`;
    
    // Redirect to the new product page
    window.location.href = newUrl;
}

// Initialize product toggles
function initializeProductToggles() {
    const singlesBtn = document.getElementById('show-singles');
    const bundlesBtn = document.getElementById('show-bundles');
    
    if (singlesBtn && bundlesBtn) {
        // Add click handlers
        singlesBtn.addEventListener('click', () => toggleProductView(false));
        bundlesBtn.addEventListener('click', () => toggleProductView(true));
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    initializeProductToggles();
    
    // Set initial button visibility based on current URL
    const isBundlePage = window.location.pathname.includes('bundles-laundry-detergent');
    const singlesBtn = document.getElementById('show-singles');
    const bundlesBtn = document.getElementById('show-bundles');
    
    if (singlesBtn && bundlesBtn) {
        singlesBtn.style.display = isBundlePage ? 'block' : 'none';
        bundlesBtn.style.display = isBundlePage ? 'none' : 'block';
    }
    
    // Check if this is a sample pack or fav trio
    const productTitle = document.querySelector('.product__title')?.textContent?.trim();
    const isSamplePack = productTitle && productTitle.toLowerCase().includes('sample pack');
    const isFavTrio = productTitle && productTitle.toLowerCase().includes('fav trio');

    if (isSamplePack || isFavTrio) {
        console.log(`${isSamplePack ? 'Sample Pack' : 'Fav Trio'} detected during initialization`);
        const mainProduct = document.querySelector('.main-product');
        if (mainProduct) {
            mainProduct.setAttribute('ref', isSamplePack ? 'sample-pack' : 'fav-trio');
            // Update any title elements
            document.querySelectorAll('.pt_alter').forEach(el => {
                el.textContent = isSamplePack ? 'Sample Pack' : 'Fav Trio';
            });
        }
    }
});

// Bundle Product Image Switching
document.addEventListener('DOMContentLoaded', function() {
    const bundleProduct = document.querySelector('.product-form__input--swatch');
    if (bundleProduct) {
        const swatches = bundleProduct.querySelectorAll('input[type="radio"]');
        const mainSlider = document.querySelector('.swiper-main');
        const thumbnailSlider = document.querySelector('.swiper-thumbnails');
        
        if (mainSlider && thumbnailSlider) {
            swatches.forEach(swatch => {
                swatch.addEventListener('change', function() {
                    const variantName = this.value.toLowerCase().replace(/\s+/g, '-');
                    
                    // Update product title when variant changes
                    let formattedTitle = this.value;
                    // Properly capitalize the title
                    formattedTitle = formattedTitle.split(' ').map(word => {
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }).join(' ');
                    
                    // Update all elements with pt_alter class
                    document.querySelectorAll('.pt_alter').forEach(el => {
                        el.textContent = formattedTitle;
                    });
                    
                    // Handle image slides
                    const mainSlides = mainSlider.querySelectorAll('.swiper-slide');
                    const thumbnailSlides = thumbnailSlider.querySelectorAll('.swiper-slide');
                    
                    mainSlides.forEach(slide => {
                        const img = slide.querySelector('img');
                        if (img && img.alt.toLowerCase().includes(variantName)) {
                            slide.style.display = 'block';
                        } else {
                            slide.style.display = 'none';
                        }
                    });
                    
                    thumbnailSlides.forEach(slide => {
                        const img = slide.querySelector('img');
                        if (img && img.alt.toLowerCase().includes(variantName)) {
                            slide.style.display = 'block';
                        } else {
                            slide.style.display = 'none';
                        }
                    });
                    
                    // Update Swiper
                    if (mainSlider.swiper) {
                        mainSlider.swiper.update();
                    }
                    if (thumbnailSlider.swiper) {
                        thumbnailSlider.swiper.update();
                    }
                });
            });
        }
    }
});

// Update click handler for bundle qty selectors
$(".qty-pack-bundle-select").click(function () {
    $(".qty-pack-bundle-select").removeClass("active");
    $(this).addClass("active");
    let size = $(this).attr("ref");
    $(".main-product").attr("ref2", "bundle-"+size);
    
    // Use our centralized function to update quantity inputs consistently
    updateQuantityFromPackSize();
    
    // Update the variant ID in the form based on the bundle size
    updateVariantIdByPackSize(size, "oasis-bundle");
    
    updateProductPrice();
});

// Update load info text based on variant
document.addEventListener('DOMContentLoaded', function() {
  const loadInfo = document.querySelector('.load-info');
  const showSinglesBtn = document.getElementById('show-singles');
  const showBundlesBtn = document.getElementById('show-bundles');

  if (loadInfo) {
    // Check if we're on the bundles page
    const isBundlesPage = window.location.pathname.includes('bundles-laundry-detergent');
    
    // Set initial text based on URL
    loadInfo.textContent = isBundlesPage ? loadInfo.dataset.bundle : loadInfo.dataset.single;

    // Update on button click if buttons exist
    if (showSinglesBtn && showBundlesBtn) {
      showSinglesBtn.addEventListener('click', function() {
        loadInfo.textContent = loadInfo.dataset.single;
      });

      showBundlesBtn.addEventListener('click', function() {
        loadInfo.textContent = loadInfo.dataset.bundle;
      });
    }
  }
});

// Product handle constants
const PRODUCT_HANDLES = {
    live: {
        singles: 'laundry-detergent',
        bundles: 'bundles-laundry-detergent'
    },
    test: {
        singles: 'test-singles-laundry-detergent',
        bundles: 'test-bundles-laundry-detergent'
    }
};

// Function to determine if we're in test mode
function isTestProduct() {
    return window.location.pathname.includes('test-');
}

// Function to get the appropriate product handle
function getProductHandle(type) {
    const mode = isTestProduct() ? 'test' : 'live';
    return PRODUCT_HANDLES[mode][type];
}

// Product toggle functionality
document.addEventListener('DOMContentLoaded', function() {
    const singlesBtn = document.getElementById('show-singles');
    const bundlesBtn = document.getElementById('show-bundles');
    
    if (!singlesBtn || !bundlesBtn) return;

    function updateProductDisplay(isBundleView) {
        // Update button visibility
        singlesBtn.style.display = isBundleView ? 'block' : 'none';
        bundlesBtn.style.display = isBundleView ? 'none' : 'block';

        // Add or remove bundles-view class from the main product container
        const productContainer = document.querySelector('.main-product');
        if (productContainer) {
            if (isBundleView) {
                productContainer.classList.add('bundles-view');
            } else {
                productContainer.classList.remove('bundles-view');
            }
        }

        // Update variant pickers visibility
        const swatchPicker = document.querySelector('.product-form__input--swatch');
        const pillPicker = document.querySelector('.product-form__input--pill');
        if (swatchPicker && pillPicker) {
            swatchPicker.style.display = isBundleView ? 'block' : 'none';
            pillPicker.style.display = isBundleView ? 'none' : 'block';
        }

        // Update product title and attributes
        const mainProduct = document.querySelector('.main-product');
        if (mainProduct) {
            // Don't override the product type if it already exists
            if (!mainProduct.getAttribute('ref')) {
                // Only set a fallback product type if it's not already set
                mainProduct.setAttribute('ref', isBundleView ? 'sample-pack' : 'italian-riviera');
            }
            mainProduct.setAttribute('ref2', '1-pack');
        }

        // Update load info text
        const loadInfo = document.querySelector('.load-info');
        if (loadInfo) {
            loadInfo.textContent = isBundleView ? loadInfo.dataset.bundle : loadInfo.dataset.single;
        }

        // Update product title
        const productTitle = document.querySelector('.pt_alter');
        if (productTitle) {
            // Check for sample pack title
            const currentTitle = document.querySelector('.product__title')?.textContent?.trim();
            if (isBundleView && currentTitle && currentTitle.toLowerCase().includes('sample pack')) {
                productTitle.textContent = 'Sample Pack';
            } else if (!isBundleView) {
                // For single product view, use Italian Sea Salt as default
                productTitle.textContent = 'Italian Sea Salt';
            }
            // For other cases, don't change the title
        }

        // Update URL without page reload
        const newUrl = `/products/${isBundleView ? 'bundles-laundry-detergent' : 'laundry-detergent'}`;
        window.history.pushState({ path: newUrl }, '', newUrl);

        // Update quantity and price
        updateProductPrice();
    }

    // Handle button clicks
    singlesBtn.addEventListener('click', () => updateProductDisplay(false));
    bundlesBtn.addEventListener('click', () => updateProductDisplay(true));

    // Set initial state based on URL
    const isBundlePage = window.location.pathname.includes('bundles-laundry-detergent');
    updateProductDisplay(isBundlePage);
});

document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, checking for Swiper');
    
    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
        console.error('Swiper is not loaded! Waiting for 1 second and trying again...');
        setTimeout(initSwipers, 1000);
        return;
    }

    initSwipers();
});

function initSwipers() {
    console.log('Attempting to initialize Swiper');
    
    // Get containers
    const mainSliderContainer = document.querySelector('.swiper-container.main-slider');
    const thumbnailSliderContainer = document.querySelector('.swiper-container.thumbnail-slider');

    if (!mainSliderContainer || !thumbnailSliderContainer) {
        console.error('Slider containers not found:', {
            main: !!mainSliderContainer,
            thumb: !!thumbnailSliderContainer
        });
        return;
    }

    console.log('Found slider containers, initializing Swiper instances');

    try {
        // Initialize thumbnail slider first
        const thumbnailSlider = new Swiper(thumbnailSliderContainer, {
            direction: 'vertical',
            slidesPerView: 4,
            spaceBetween: 10,
            watchSlidesProgress: true
        });

        // Initialize main slider
        const mainSlider = new Swiper(mainSliderContainer, {
            slidesPerView: 1,
            spaceBetween: 10,
            thumbs: {
                swiper: thumbnailSlider
            },
            pagination: {
                el: '.main-slider-pagination',
                clickable: true,
                type: 'bullets'
            }
        });

        // Debug pagination
        console.log('Custom.js (2nd init) - Pagination element:', document.querySelector('.main-slider-pagination'));
        console.log('Custom.js (2nd init) - Main slider pagination:', mainSlider.pagination);
        console.log('Custom.js (2nd init) - Pagination bullets:', document.querySelectorAll('.main-slider-pagination .swiper-pagination-bullet'));

        // Add event listeners to track slide changes and pagination updates
        mainSlider.on('slideChange', function () {
            console.log('Custom.js - Slide changed to:', mainSlider.activeIndex);
            console.log('Custom.js - Active bullet should be:', mainSlider.activeIndex);
            
            // Force update pagination active state
            setTimeout(() => {
                const bullets = document.querySelectorAll('.main-slider-pagination .swiper-pagination-bullet');
                bullets.forEach((bullet, index) => {
                    if (index === mainSlider.activeIndex) {
                        bullet.classList.add('swiper-pagination-bullet-active');
                    } else {
                        bullet.classList.remove('swiper-pagination-bullet-active');
                    }
                });
                console.log('Custom.js - Updated pagination bullets after slide change');
            }, 100);
        });

        // Add a periodic check to ensure pagination stays in sync
        setInterval(() => {
            if (mainSlider && mainSlider.activeIndex !== undefined) {
                const bullets = document.querySelectorAll('.main-slider-pagination .swiper-pagination-bullet');
                bullets.forEach((bullet, index) => {
                    if (index === mainSlider.activeIndex) {
                        bullet.classList.add('swiper-pagination-bullet-active');
                    } else {
                        bullet.classList.remove('swiper-pagination-bullet-active');
                    }
                });
            }
        }, 500);

        // Add click handlers for thumbnails
        thumbnailSliderContainer.querySelectorAll('.swiper-slide').forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                console.log('Thumbnail clicked:', index);
                mainSlider.slideTo(index);
            });
        });

        // Store references globally
        window.mainSlider = mainSlider;
        window.thumbnailSlider = thumbnailSlider;

        console.log('Both sliders initialized successfully');

    } catch (error) {
        console.error('Error initializing Swiper:', error);
    }
}

// Add event listeners for Loop price changes
document.addEventListener('DOMContentLoaded', function() {
    // Listen for Loop subscription option changes
    document.querySelectorAll('.loop-subscription-group-radio, .loop-one-time-purchase-option-radio')
        .forEach(radio => {
            radio.addEventListener('change', updateLoads);
        });
    
    // Listen for Loop selling plan changes
    const sellingPlanSelector = document.querySelector('.loop-selling-plan-selector');
    if (sellingPlanSelector) {
        sellingPlanSelector.addEventListener('change', updateLoads);
    }
});

// Debug Loop initialization
document.addEventListener('DOMContentLoaded', function() {
    console.log('Checking for Loop widget...');
    
    // Check if Loop widget exists
    const loopWidget = document.querySelector('#loop-subscription-container');
    if (loopWidget) {
        console.log('Loop widget found:', loopWidget.id);
        
        // Monitor Loop's price elements
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                    console.log('Loop price updated:', {
                        element: mutation.target,
                        newValue: mutation.target.textContent
                    });
                }
            });
        });
        
        // Observe one-time and subscription prices
        const priceElements = loopWidget.querySelectorAll('.loop-subscription-group-price-amount, #loop-price-one-time');
        priceElements.forEach(el => {
            observer.observe(el, { 
                childList: true, 
                characterData: true,
                subtree: true 
            });
            console.log('Observing price element:', el.id || el.className);
        });
    } else {
        console.log('Loop widget not found');
    }
});

// Check Loop initialization
document.addEventListener('DOMContentLoaded', function() {
    console.log('Checking Loop initialization...');
    
    // Check for Loop's required functions
    console.log('Loop functions available:', {
        changeInSellingPlanGroup: typeof window.changeInSellingPlanGroupLoop === 'function',
        updatePriceInUI: typeof window.updatePriceInUILoop === 'function',
        loopProps: typeof window.loopProps !== 'undefined'
    });
    
    // Check Loop's widget structure
    const loopWidget = document.querySelector('#loop-subscription-container');
    if (loopWidget) {
        console.log('Loop widget elements:', {
            subscriptionGroups: loopWidget.querySelectorAll('.loop-subscription-group').length,
            oneTimePurchase: loopWidget.querySelector('.loop-one-time-purchase-option') !== null,
            priceElements: loopWidget.querySelectorAll('.loop-subscription-group-price-amount, #loop-price-one-time').length
        });
        
        // Check if Loop's properties are properly set
        const firstSubscriptionRadio = loopWidget.querySelector('.loop-subscription-group-radio');
        if (firstSubscriptionRadio) {
            console.log('First subscription radio properties:', {
                id: firstSubscriptionRadio.dataset.id,
                name: firstSubscriptionRadio.dataset.name,
                productId: firstSubscriptionRadio.dataset.productId,
                variantId: firstSubscriptionRadio.dataset.variantId
            });
        }
    }
});

// Debug function to monitor Loop price changes
function monitorLoopPrices() {
  console.log("⏱️ Setting up Loop price monitoring...");
  
  // Get current price values
  const oneTimePrice = document.querySelector('#loop-price-one-time')?.innerHTML;
  const subscriptionPrices = Array.from(document.querySelectorAll('.loop-subscription-group-price-amount'))
    .map(el => ({ id: el.id, price: el.innerHTML }));
  
  console.log("📊 Initial price values:", { 
    oneTimePrice, 
    subscriptionPrices 
  });
  
  // Set up mutation observer to monitor price changes
  const priceObserver = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      const target = mutation.target;
      console.log("💰 Price changed:", {
        element: target.id || target.className,
        oldValue: mutation.oldValue,
        newValue: target.innerHTML,
        stack: new Error().stack
      });
    });
  });
  
  // Observe one-time price
  const oneTimePriceElement = document.querySelector('#loop-price-one-time');
  if (oneTimePriceElement) {
    priceObserver.observe(oneTimePriceElement, { 
      childList: true, 
      characterData: true, 
      subtree: true,
      characterDataOldValue: true
    });
  }
  
  // Observe subscription prices
  document.querySelectorAll('.loop-subscription-group-price-amount').forEach(el => {
    priceObserver.observe(el, { 
      childList: true, 
      characterData: true, 
      subtree: true,
      characterDataOldValue: true
    });
  });
  
  // Monitor loop option clicks with direct DOM events
  document.addEventListener('click', function(e) {
    if (e.target.matches('.loop-subscription-group-radio, .loop-one-time-purchase-option-radio') || 
        e.target.closest('.loop-subscription-group, .loop-one-time-purchase-option')) {
      console.log("🔄 Loop option clicked:", {
        element: e.target.className,
        time: new Date().toISOString()
      });
      
      // Wait a bit and log current prices
      setTimeout(() => {
        const currentOneTimePrice = document.querySelector('#loop-price-one-time')?.innerHTML;
        const currentSubscriptionPrices = Array.from(document.querySelectorAll('.loop-subscription-group-price-amount'))
          .map(el => ({ id: el.id, price: el.innerHTML }));
        
        console.log("📊 Prices after click:", { 
          currentOneTimePrice, 
          currentSubscriptionPrices,
          time: new Date().toISOString()
        });
      }, 100);
    }
  }, true);
}

// Run monitoring on page load
document.addEventListener('DOMContentLoaded', function() {
  // Wait for Loop to initialize
  setTimeout(monitorLoopPrices, 1000);
  
  // Test if updateProductPrice is still being called indirectly
  const originalUpdateProductPrice = window.updateProductPrice;
  window.updateProductPrice = function() {
    console.log("🔍 updateProductPrice called from:", new Error().stack);
    return originalUpdateProductPrice.apply(this, arguments);
  };
});

// Override Loop's displayLoopWidget function to prevent it from calling updateProductPrice
document.addEventListener('DOMContentLoaded', function() {
  console.log("🔧 Setting up Loop displayLoopWidget override...");
  
  // Wait for Loop to load
  const checkLoopExists = setInterval(() => {
    if (typeof window.displayLoopWidget === 'function') {
      clearInterval(checkLoopExists);
      console.log("✅ Found Loop's displayLoopWidget function, overriding...");
      
      // Store the original function
      const originalDisplayLoopWidget = window.displayLoopWidget;
      
      // Override with our own version that uses applyPackSizePrices instead of updateProductPrice
      window.displayLoopWidget = function(productId) {
        console.log("🛠️ Using overridden displayLoopWidget for product ID:", productId);
        const loopWidget = window.getLoopSubscriptionContainer(productId);
        if (loopWidget) {
          window.selectLoopSubscription();
          // Use our new function to apply correct pack size prices
          applyPackSizePrices();
          loopWidget.classList.remove("loop-display-none");
          console.log("✅ Loop widget displayed with correct pack size prices");
        }
      };
      
      console.log("✅ Successfully overrode Loop's displayLoopWidget function");
    }
  }, 200);
});

// Override Loop's changeInSellingPlanGroupLoop function to ensure correct prices
document.addEventListener('DOMContentLoaded', function() {
  console.log("🔧 Setting up Loop event handler overrides...");
  
  // Wait for Loop to load
  const checkLoopExists = setInterval(() => {
    if (typeof window.changeInSellingPlanGroupLoop === 'function') {
      clearInterval(checkLoopExists);
      console.log("✅ Found Loop event handlers, setting up overrides...");
      
      // Create patches for functions that might indirectly call updateProductPrice
      const functionsToPatch = [
        'changeInSellingPlanGroupLoop',
        'changeInDeliveryOptionLoop'
      ];
      
      functionsToPatch.forEach(funcName => {
        if (typeof window[funcName] === 'function') {
          const originalFunc = window[funcName];
          window[funcName] = function() {
            console.log(`🛠️ Using patched ${funcName}`);
            
            // Set a flag to indicate we're in a Loop context
            window._isLoopPriceUpdate = true;
            
            // Call the original function
            const result = originalFunc.apply(this, arguments);
            
            // After Loop updates its own prices, we need to apply our pack size prices
            setTimeout(() => {
              // Clear the flag
              window._isLoopPriceUpdate = false;
              
              // CRITICAL FIX: Always apply our pack size prices after Loop's subscription toggle
              applyPackSizePrices();
              
              console.log(`✅ Completed ${funcName} with correct pack size prices`);
            }, 150);
            
            return result;
          };
          console.log(`✅ Successfully patched ${funcName}`);
        }
      });
      
      // Also patch updatePriceInUILoop but with different handling
      if (typeof window.updatePriceInUILoop === 'function') {
        const originalUpdatePrice = window.updatePriceInUILoop;
        window.updatePriceInUILoop = function() {
          console.log(`🛠️ Using patched updatePriceInUILoop`);
          
          // Call the original function
          const result = originalUpdatePrice.apply(this, arguments);
          
          // After Loop updates its own prices
          setTimeout(() => {
            // Apply our pack size prices
            applyPackSizePrices();
            
            console.log(`✅ Completed updatePriceInUILoop with correct pack size prices`);
          }, 50);
          
          return result;
        };
      }
    }
  }, 200);
});

// New function to apply correct prices based on pack size
function applyPackSizePrices() {
  // Get the current active pack size
  const activeQty = $(".qty-pack-select.active").attr("ref");
  if (!activeQty) return;
  
  const currentQty = parseInt(activeQty);
  const productType = $(".main-product").attr("ref");
  const isBundlesView = $(".main-product").hasClass("bundles-view");
  const isSamplePack = productType === 'sample-pack';
  
  // Base prices for each quantity pack (one-time purchase)
  const basePrices = isSamplePack ? {
      3: 104.99  // Sample pack (200 loads) fixed price
  } : isBundlesView ? {
      1: 69.99,  // 100 loads bundle (quantity 1)
      2: 104.99   // 200 loads bundle (quantity 2)
  } : {
      1: 34.99,  // 50 loads
      2: 69.99,  // 100 loads
      3: 139.99   // 200 loads
  };
  
  // Exact subscription prices (no percentage calculation)
  const subscriptionPrices = isSamplePack ? {
      3: 74.99  // Sample pack (200 loads) fixed subscription price
  } : isBundlesView ? {
      1: 49.99,  // 100 loads bundle (quantity 1)
      2: 74.99   // 200 loads bundle (quantity 2)
  } : {
      1: 24.99,  // 50 loads
      2: 49.99,  // 100 loads
      3: 74.99   // 200 loads
  };
  
  // Get base price for current quantity
  const basePrice = basePrices[currentQty];
  if (!basePrice) return;
  
  console.log("🔄 Applying prices for pack size:", currentQty, "with base price:", basePrice, "product type:", productType);
  
  // Update one-time purchase price
  const oneTimePriceElement = document.querySelector('#loop-price-one-time');
  if (oneTimePriceElement) {
    oneTimePriceElement.innerHTML = formatPrice(basePrice);
  }
  
  // Update subscription prices with exact values
  document.querySelectorAll('.loop-subscription-group-price-amount').forEach(priceElement => {
    const subscriptionPrice = subscriptionPrices[currentQty];
    priceElement.innerHTML = formatPrice(subscriptionPrice);
  });

  // Update original subscription prices
  document.querySelectorAll('.loop-subscription-group-price-amount-original').forEach(priceElement => {
    // For sample pack, use $139.99 as the original price, otherwise use the base price
    const originalPrice = isSamplePack ? 174.99 : basePrice;
    priceElement.innerHTML = `<s>${formatPrice(originalPrice)}</s>`;
  });

  // Add discount badge rounding logic here
  document.querySelectorAll('.loop-subscription-group-discount-badge:not(.loop-subscription-group-discount-badge-onetime)').forEach(badge => {
    badge.classList.remove('loop-display-none');
    // Calculate actual savings
    const savings = Math.round(((basePrice - subscriptionPrices[currentQty]) / basePrice) * 100);
    // For sample pack, always show 37%
    const isSamplePack = $(".main-product").attr("ref") === "sample-pack";
    badge.textContent = isSamplePack ? 'SAVE $100' : `SAVE ${savings}%`;
  });
  
  // Hide one-time purchase discount badge
  document.querySelector('.loop-subscription-group-discount-badge-onetime')?.classList.add('loop-display-none');

      // Show original subscription prices
    document.querySelectorAll('.loop-subscription-group-price-amount-original').forEach(el => {
        el.classList.remove('loop-display-none');
      });
    
    // Show original one-time purchase price only for sample pack
    document.querySelectorAll('.loop-one-time-purchase-option-price-amount-original').forEach(el => {
        if (isSamplePack) {
            el.classList.remove('loop-display-none');
            // Add strikethrough styling
            el.style.textDecoration = 'line-through';
        } else {
            el.classList.add('loop-display-none');
            // Remove strikethrough styling
            el.style.textDecoration = 'none';
        }
    });
  
  // Update price per load displays
  const loads = isSamplePack ? {
    3: 200  // Sample pack always 200 loads
  } : isBundlesView ? {
    1: 100,  // 100 loads bundle (quantity 1)
    2: 200   // 200 loads bundle (quantity 2)
  } : {
    1: 50,   // 50 loads
    2: 100,  // 100 loads
    3: 200   // 200 loads
  };
  
  const totalLoads = loads[currentQty];
  if (totalLoads) {
    const pricePerLoad = (basePrice / totalLoads).toFixed(2);
    document.querySelectorAll('.priceperload-txt').forEach(element => {
      element.textContent = `($${pricePerLoad} / Load)`;
    });
  }
}

// Initialize MutationObserver to monitor forms for changes
function initFormObserver() {
    console.log('🔍 Setting up form observer');
    
    // Find all forms that might contain variant IDs
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    
    forms.forEach((form, index) => {
        console.log(`📋 Setting up observer for form ${index}`);
        
        // Create a mutation observer to watch for changes to the form
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                // Check if the variant ID input value changed
                if (mutation.type === 'attributes' && 
                    mutation.target.tagName === 'INPUT' && 
                    (mutation.target.name === 'id' || mutation.target.name === 'quantity')) {
                    
                    console.log(`⚠️ Form ${index} ${mutation.target.name} changed`);
                    
                    // Get the current product type and pack size
                    const mainProduct = document.querySelector('.main-product');
                    if (mainProduct) {
                        const productType = mainProduct.getAttribute('ref');
                        const packSize = mainProduct.getAttribute('ref2')?.replace('-pack', '') || '2';
                        const isBundle = productType === 'oasis-bundle';
                        
                        // If it's the quantity field that changed
                        if (mutation.target.name === 'quantity') {
                            // Get the expected quantity from our mapping
                            const qtyMap = isBundle ? quantityMappings.bundle : quantityMappings.single;
                            const expectedQuantity = qtyMap[packSize] || packSize;
                            
                            // If the quantity is wrong, fix it
                            if (mutation.target.value != expectedQuantity) {
                                console.log(`🔄 Restoring correct quantity: ${expectedQuantity} for pack size ${packSize}`);
                                mutation.target.value = expectedQuantity;
                                
                                // Dispatch change event
                                const event = new Event('change', { bubbles: true });
                                mutation.target.dispatchEvent(event);
                            }
                        }
                        // If it's the variant ID field that changed
                        else if (mutation.target.name === 'id') {
                            // Check if the input value is different from what we expect
                            const variantInput = mutation.target;
                            const expectedVariantId = updateVariantIdByPackSize(packSize, productType);
                            
                            if (expectedVariantId && variantInput.value !== expectedVariantId) {
                                console.log(`🔄 Restoring correct variant ID for ${productType}, pack size: ${packSize}`);
                                variantInput.value = expectedVariantId;
                                
                                // Dispatch change event
                                const event = new Event('change', { bubbles: true });
                                variantInput.dispatchEvent(event);
                            }
                        }
                    }
                }
            });
        });
        
        // Start observing
        observer.observe(form, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['value']
        });
    });
}

// Initialize variant selection and pagination
document.addEventListener('DOMContentLoaded', function() {
    console.log('🚀 DOM fully loaded and parsed');
    
    // Check if this is a sample pack product
    checkForSamplePack();
    
    // Wait a short period to make sure the variant-selects are fully initialized
    setTimeout(() => {
        // Initialize the pack size variant ID
        const mainProduct = document.querySelector('.main-product');
        if (mainProduct) {
            console.log('🏁 Initializing pack size variant ID');
            const productType = mainProduct.getAttribute('ref');
            
            // Set default pack size attributes
            const isBundle = productType === 'oasis-bundle';
            const isSamplePack = productType === 'sample-pack';
            const isFavTrio = productType === 'fav-trio';
            const isSingleProduct = ['italian-riviera', 'african-sandalwood', 'maldivian-palm', 'french-cognac'].includes(productType);
            
            // Set default pack size (100 loads = '2') for single products
            if (isSingleProduct) {
                console.log('Setting default packSize to 2 (100 loads) for single product');
                mainProduct.setAttribute('ref2', '2-pack');
                
                // Ensure only 100 loads button is active
                $(".qty-pack-select").removeClass("active");
                $('.qty-pack:not(.bundle-qty-pack) .qty-pack-2').addClass('active');
            } else {
                // For non-single products, check existing packSize or default to 2
                const packSizeData = mainProduct.getAttribute('ref2');
                const packSize = packSizeData ? packSizeData.replace('-pack', '') : '2';
                console.log(`Initial productType: ${productType}, packSize: ${packSize}`);
            }
            
            const packSize = mainProduct.getAttribute('ref2')?.replace('-pack', '') || '2';
            
            // Set initial visibility of sub-benefits-gift-eligible elements
            const giftEligibleElements = document.querySelectorAll('.sub-benefits-gift-eligible');
            if (packSize === '1') {
                // Hide gift-eligible elements when 50 loads is selected
                giftEligibleElements.forEach(element => {
                    element.style.display = 'none';
                });
            } else {
                // Show gift-eligible elements for other pack sizes
                giftEligibleElements.forEach(element => {
                    element.style.display = '';
                });
            }
            
            // Set the quantity based on the mapping or 1 for sample pack
            if (isSamplePack || isFavTrio) {
                const qtyInput = document.querySelector('input[name="quantity"]');
                if (qtyInput) {
                    qtyInput.value = 1;
                    console.log(`Setting sample pack or fav trio quantity to 1`);
                }
            } else {
                const qtyMap = isBundle ? quantityMappings.bundle : quantityMappings.single;
                const mappedQuantity = qtyMap[packSize] || packSize;
                const qtyInput = document.querySelector('input[name="quantity"]');
                
                if (qtyInput) {
                    qtyInput.value = mappedQuantity;
                    console.log(`Setting initial quantity to ${mappedQuantity}`);

                    setTimeout(() => {
                        console.log("⏱️ Quantity after 500ms:", document.querySelector('input[name="quantity"]').value);
                    }, 500);
                }
            }
            
            // Set the variant ID based on the current pack size
            const variantId = updateVariantIdByPackSize(packSize, productType);
            console.log(`Initialized variant ID: ${variantId}`);
            
            // Apply the appropriate styling for product type
            if (isSamplePack || isFavTrio) {
                // For sample pack and fav trio, check if we need to update the UI
                updateButtonVisibility(false);
            } else {
                // For other products, call updateButtonVisibility to set proper UI state
                updateButtonVisibility(isBundle);
            }
        }
       
    }, 100);
});

// Function to check if the current product is a sample pack or fav trio
function checkForSamplePack() {
    const productTitle = document.querySelector('.product__title')?.textContent?.trim();
    const isSamplePack = productTitle?.toLowerCase().includes('sample pack');
    const isFavTrio = productTitle?.toLowerCase().includes('fav trio');

    if (isSamplePack || isFavTrio) {
        console.log(`📦 ${isSamplePack ? 'Sample Pack' : 'Fav Trio'} product detected`);

        // Set the product type attribute
        $(".main-product").attr("ref", isSamplePack ? "sample-pack" : "fav-trio");

        // Set correct pack size for sample pack and fav trio (using size 3 for 200 loads)
        $(".main-product").attr("ref2", "3-pack");

        // Hide all quantity selectors except 200 loads
        $(".qty-pack-select").hide();
        $(".qty-pack-3.qty-pack-select").show();
        $(".qty-pack-select").removeClass("active");
        $(".qty-pack-3.qty-pack-select").addClass("active");

        // Make sure the right quantity divs are visible - hide bundle, show singles
        $(".bundle-qty-pack").hide();
        $(".qty-pack:not(.bundle-qty-pack)").show();

        // Set quantity to 1 and max to 1
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) {
            qtyInput.value = 1;
            qtyInput.setAttribute('max', '1');
            // Trigger change event
            const event = new Event('change', { bubbles: true });
            qtyInput.dispatchEvent(event);
        }

        // Set the UI immediately
        updateButtonVisibility(false);
    }
}

// Define a global quantityMappings object for consistent quantity handling across the site
window.quantityMappings = {
    single: { '1': 1, '2': 2, '3': 4 },  // 3-pack is 4 quantity for singles
    bundle: { '1': 1, '2': 2 }           // Simple 1:1 mapping for bundles
};

/**
 * Ensures all forms have quantity inputs - creates them if missing
 * This prevents errors when updating quantities from pack selection
 * @returns {boolean} True if all forms have quantity inputs, false if any needed to be created
 */
function ensureQuantityInputsExist() {
    console.log('🔍 Ensuring all forms have quantity inputs');
    let allFormsHaveInputs = true;
    
    // Find all forms
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form, index) => {
        // Check if the form already has a quantity input
        let quantityInput = form.querySelector('input[name="quantity"]');
        
        if (!quantityInput) {
            console.log(`⚠️ Form ${index} is missing quantity input, creating one`);
            allFormsHaveInputs = false;
            
            // Get the appropriate quantity
            const mainProduct = document.querySelector('.main-product');
            if (mainProduct) {
                const packSize = mainProduct.getAttribute('ref2')?.replace('-pack', '') || '2';
                const productType = mainProduct.getAttribute('ref');
                const isBundle = productType === 'oasis-bundle' || productType?.includes('duo');
                const isSamplePack = productType === 'sample-pack';
                
                // Determine the correct quantity
                let qty;
                if (isSamplePack) {
                    qty = 1; // Sample pack is always quantity 1
                } else {
                    // Get from the mappings
                    const qtyMap = isBundle ? window.quantityMappings.bundle : window.quantityMappings.single;
                    qty = qtyMap[packSize] || (isBundle ? 1 : 2); // Default to 1 for bundles, 2 for singles
                }
                
                // Create and add the quantity input
                quantityInput = document.createElement('input');
                quantityInput.type = 'hidden';
                quantityInput.name = 'quantity';
                quantityInput.value = qty;
                form.appendChild(quantityInput);
                
                console.log(`✅ Added quantity=${qty} to form ${index}`);
            }
        }
    });
    
    return allFormsHaveInputs;
}

/**
 * Updates all quantity inputs based on the selected pack size
 * @returns {number} The new quantity value
 */
function updateQuantityFromPackSize() {
    // Get the pack size and product type
    const mainProduct = document.querySelector('.main-product');
    if (!mainProduct) return 0;
    
    const packSize = mainProduct.getAttribute('ref2')?.replace('-pack', '') || '2';
    const productType = mainProduct.getAttribute('ref');
    const isBundle = productType === 'oasis-bundle' || productType?.includes('duo');
    const isSamplePack = productType === 'sample-pack';
    // FAVORITE-TRIO PATCH START
    const isFavTrio = productType === 'fav-trio';
    // FAVORITE-TRIO PATCH END
    
    // Get the correct quantity for the pack size
    let qty;
    // FAVORITE-TRIO PATCH START
    if (isSamplePack || isFavTrio) {
    // FAVORITE-TRIO PATCH END
        qty = 1; // Sample pack is always quantity 1
    } else {
        // Get from our mappings
        const qtyMap = isBundle ? window.quantityMappings.bundle : window.quantityMappings.single;
        qty = qtyMap[packSize] || (isBundle ? 1 : 2); // Default to 1 for bundles, 2 for singles
    }
    
    // Update all quantity inputs
    document.querySelectorAll('input[name="quantity"]').forEach(input => {
        input.value = qty;
        
        // Also dispatch change event
        const event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);
    });
    
    console.log(`📦 Updated all quantity inputs to ${qty} for pack size ${packSize}`);
    return qty;
}

// Start observing the document body for changes
observer.observe(document.body, {
    childList: true,
    subtree: true
});

// Global function to test pagination (can be called from browser console)
window.testPagination = function() {
    console.log('🧪 Testing pagination functionality...');
    
    // Check if pagination element exists
    const paginationEl = document.querySelector('.main-slider-pagination');
    console.log('Pagination element:', paginationEl);
    
    if (paginationEl) {
        const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
        console.log('Number of bullets:', bullets.length);
        
        bullets.forEach((bullet, index) => {
            console.log(`Bullet ${index}:`, {
                element: bullet,
                hasActiveClass: bullet.classList.contains('swiper-pagination-bullet-active'),
                styles: window.getComputedStyle(bullet)
            });
        });
    }
    
    // Check all Swiper instances
    console.log('All Swiper instances:', {
        windowMainSlider: window.mainSlider,
        windowThumbnailSlider: window.thumbnailSlider
    });
    
    // Test manual slide change
    if (window.mainSlider) {
        console.log('Current active index:', window.mainSlider.activeIndex);
        console.log('Total slides:', window.mainSlider.slides.length);
    }
};

// Global function to manually update pagination
window.updatePagination = function() {
    if (window.mainSlider && window.mainSlider.activeIndex !== undefined) {
        const bullets = document.querySelectorAll('.main-slider-pagination .swiper-pagination-bullet');
        bullets.forEach((bullet, index) => {
            if (index === window.mainSlider.activeIndex) {
                bullet.classList.add('swiper-pagination-bullet-active');
            } else {
                bullet.classList.remove('swiper-pagination-bullet-active');
            }
        });
        console.log('✅ Manually updated pagination to index:', window.mainSlider.activeIndex);
    } else {
        console.log('❌ No mainSlider found or activeIndex undefined');
    }
};
